// Additional full translations (merged into STRINGS in I18nContext).
// Languages: Spanish (es), Arabic (ar, RTL), Hindi (hi), Mandarin Chinese (zh).

export const es = {
  safe_trade_title: "Compra y vende con seguridad", safe_trade_dismiss: "Entendido",
  safe_tip_1: "Para ventas locales, quedad en un lugar público concurrido.",
  safe_tip_2: "Inspecciona el artículo en persona antes de pagar.",
  safe_tip_3: "Nunca pagues por adelantado ni compartas códigos OTP / tarjeta / PIN.",
  safe_tip_4: "Si un precio parece demasiado bueno, desconfía.",
  scam_warning: "Condiciones de pago arriesgadas. Nunca pagues por adelantado ni compartas códigos.",
  scam_compose_warning: "Esto parece arriesgado. Mantente seguro — evita pagos por adelantado y códigos.",
  photo_tips: "Consejos de fotos", photo_tips_title: "Las buenas fotos venden más rápido",
  photo_tip_1: "Fotografía con luz natural y brillante.",
  photo_tip_2: "Muestra varios ángulos del artículo.",
  photo_tip_3: "Usa un fondo limpio y despejado.",
  photo_tip_4: "Muestra los defectos con honestidad para generar confianza.",
  photo_tip_5: "Llena el encuadre — acércate al artículo.",
  help_guide: "Guía", guide_got_it: "Entendido", coming_soon: "Próximamente",
  guide_social_title: "Cómo moverte en Social",
  guide_social_1: "Feed — publicaciones de amigos y de quienes sigues. Cambia a Descubrir.",
  guide_social_2: "Amigos — encuentra personas, acepta solicitudes y descubre usuarios.",
  guide_social_3: "Buzón — mensajes privados, ahora con fotos, vídeo y notas de voz.",
  guide_social_4: "Yo — tu perfil, publicaciones y estadísticas. El menú ⋯ permite seguir, compartir o reportar.",
  guide_market_title: "Cómo moverte en el Mercado",
  guide_market_1: "Explorar — busca artículos y toca una tarjeta para ver los detalles.",
  guide_market_2: "Guardados — artículos que marcaste para más tarde.",
  guide_market_3: "Mi tienda — publica artículos, haz promociones y gestiona tu tienda.",
  guide_market_4: "Buzón — habla con compradores o vendedores. Busca la insignia dorada ✔ de vendedor verificado.",
  open_app: "Abrir app", get_started: "Empezar", install: "Instalar RoyalChat Nova", download_royalchat: "Descargar RoyalChat Nova",
  login: "Iniciar sesión", register: "Crear cuenta", email: "Correo", password: "Contraseña",
  name: "Nombre completo", chats: "Mensajes", search: "Buscar chats…", new_chat: "Nuevo chat",
  settings: "Ajustes", logout: "Cerrar sesión", type_message: "Escribe un mensaje…",
  pinned: "Fijados", all_chats: "Todos los chats", online: "en línea", typing: "escribiendo…",
  pin: "Fijar", schedule: "Programar",
  no_chats: "Aún no hay conversaciones", start_conversation: "Inicia una conversación",
  profile: "Perfil", theme: "Tema", language: "Idioma", dark: "Oscuro", light: "Claro",
  ai_assistant: "Asistente IA", admin: "Admin", read_aloud: "Leer en voz alta",
  admin_panel_desc: "Gestiona usuarios, medios y difusiones",
  tab_chats: "Chats", tab_calls: "Llamadas", tab_settings: "Ajustes", tab_social: "Social", tab_market: "Mercado",
  appearance: "Apariencia", preferences: "Preferencias", network: "Red", connected: "Conectado",
  notifications: "Notificaciones", edit_profile: "Editar perfil", phone: "Número de teléfono",
  data_usage: "Uso de datos", used_today: "usados hoy",
  ultra_lite: "Modo Ultraligero", ultra_lite_desc: "Solo texto: medios al tocar, sin vistas previas de enlaces",
  auto_delete_media: "Autoeliminar medios", auto_delete_desc: "Borra los medios más antiguos para liberar espacio",
  app_lock: "Bloqueo de app", app_lock_desc: "Requiere un PIN para abrir la app", app_lock_on: "Activo · PIN requerido al abrir",
  notifications_on: "Notificaciones activadas", notifications_blocked: "Notificaciones bloqueadas",
  ios_install_for_push: "En iPhone: toca Compartir → Añadir a pantalla de inicio, luego abre RoyalChat Nova desde ahí para activar las notificaciones.",
  country: "País", about: "Acerca de", change_password: "Cambiar contraseña", save: "Guardar", cancel: "Cancelar",
  pw_current: "Contraseña actual", pw_new: "Nueva contraseña", pw_update: "Actualizar", pw_updated: "Contraseña actualizada ✓", pw_fill_both: "Introduce la contraseña actual y la nueva", pw_too_short: "La nueva contraseña debe tener al menos 6 caracteres", pw_change_failed: "No se pudo cambiar la contraseña",
  or_pick_avatar: "O elige un avatar", calls: "Llamadas", all: "Todas", missed: "Perdidas", no_calls: "Aún no hay llamadas",
  configure_ai: "Configurar IA", get_free_key: "Obtener clave gratis", how_get_key: "Cómo obtener tu clave (1 min, sin tarjeta)",
  welcome_back: "Bienvenido de nuevo", signin_continue: "Inicia sesión para continuar tus conversaciones.",
  join_royalchat: "Únete a RoyalChat Nova", create_seconds: "Crea tu cuenta en segundos.",
  forgot_password: "¿Olvidaste tu contraseña?", new_here: "¿Nuevo en RoyalChat Nova?", already_account: "¿Ya tienes una cuenta?",
  reset_pw_title: "Restablecer contraseña", reset_pw_desc: "Ingresa tu correo para recibir un enlace de restablecimiento.",
  send_reset: "Enviar enlace", back_login: "Volver al inicio de sesión", back_home: "Volver al inicio",
  readonly_notice: "Este es un canal oficial de RoyalChat Nova — no puedes responder aquí.",
  channel_readonly_notice: "Solo los admins pueden publicar en este canal.",
  create_account_title: "Crea\ntu cuenta", create_account_sub: "Únete a RoyalChat Nova y empieza a chatear",
  create_account_cta: "Crear la cuenta", login_tagline: "Donde las conversaciones se vuelven reales",
  email_or_phone: "Correo o número de teléfono", continue_google: "Continuar con Google", or_divider: "O",
  search_country: "Buscar país…", no_results: "Sin resultados", today: "Hoy", yesterday: "Ayer",
  complete_profile_prompt: "Añade tu país y teléfono para que tus amigos te encuentren y llamen.",
  complete_profile_cta: "Completar perfil", dismiss: "Descartar", remove_key: "Quitar clave", key_removed: "Clave eliminada",
  attach_photos: "Fotos", attach_document: "Documento", attach_sticker: "Sticker", attach_camera: "Cámara", poll: "Encuesta",
  read_receipts: "Confirmaciones de lectura", read_receipts_desc: "Mostrar marcas azules al leer mensajes",
  sending_tap_cancel: "Enviando… toca para cancelar", recording: "Grabando…",
  data_storage: "Datos y almacenamiento", data_saver: "Ahorro de datos", data_saver_desc: "Comprime mucho fotos, audio y video",
  auto_download: "Descarga automática de medios", autodl_off: "Nunca", autodl_wifi: "Solo Wi-Fi", autodl_always: "Siempre",
  auto_download_desc: "Elige qué medios se descargan automáticamente", mt_images: "Imágenes", mt_audio: "Audio", mt_video: "Vídeo", mt_documents: "Documentos",
  clear_media_title: "¿Borrar medios almacenados?", clear_media_warn: "Esto elimina permanentemente todas las fotos, vídeos, audios y documentos descargados en este dispositivo. Se volverán a descargar la próxima vez que los abras.", clear_media_confirm: "Borrar",
  undo_send_title: "Deshacer antes de enviar", undo_send_desc: "Retrasa los mensajes para poder cancelar",
  storage_cleanup: "Borrar medios guardados", storage_cleanup_desc: "Elimina fotos, audio y docs guardados en este dispositivo", storage_cleared: "Almacenamiento borrado",
  help_support: "Ayuda y soporte", help_support_desc: "Preguntas frecuentes y cómo obtener ayuda", privacy_help: "Privacidad y ayuda",
  sounds_ringtones: "Sonidos y tonos", sound_effects: "Efectos de sonido", sound_effects_desc: "Reproducir tonos para envíos, recibidos y llamadas",
  tone_sent: "Mensaje enviado", tone_received: "Mensaje recibido", tone_call: "Llamada entrante",
  verify_email: "Verificar mi correo", verified: "Verificado", not_verified: "No verificado",
  verify_email_desc: "Obtén una insignia de verificado en tu cuenta",
  verify_intro: "Enviaremos un código de 6 dígitos a tu correo para confirmar que eres tú.",
  verify_send_code: "Enviar código", verify_enter_code: "Ingresa el código de 6 dígitos enviado a tu correo",
  verify_confirm: "Verificar correo", verify_success: "Correo verificado", verify_code_sent: "Código enviado a tu correo",
  verify_invalid: "Código inválido o expirado", verify_resend: "Reenviar código", already_verified: "Tu correo está verificado",
  blocked_contacts: "Contactos bloqueados", blocked_contacts_desc: "Gestiona las personas que bloqueaste",
  no_blocked: "No has bloqueado a nadie", unblock: "Desbloquear", block: "Bloquear", block_contact: "Bloquear contacto",
  blocked_toast: "Contacto bloqueado", unblocked_toast: "Contacto desbloqueado",
  tap_to_download: "Toca para descargar", poor_connection_quality: "Conexión débil · calidad reducida", call_reconnecting: "Reconectando…",
  copied: "Copiado", forward: "Reenviar", forward_to: "Reenviar a", forwarded: "Reenviado",
  this_chat: "Este chat", messages_label: "mensajes", one_message_label: "1 mensaje",
  reply: "Responder", forwarded_label: "Reenviado", you: "Tú",
  copy: "Copiar", delete: "Eliminar", open: "Abrir", download: "Descargar",
  load_older: "Cargar mensajes anteriores", loading_older: "Cargando…", jump_to_latest: "Ir a lo más reciente",
  land_badge: "La experiencia de mensajería premium",
  land_hero_1: "Donde cada conversación se siente", land_hero_accent: "de primera clase",
  land_hero_sub: "Un mensajero exquisitamente diseñado — llamadas refinadas, un asistente inteligente y una experiencia de máximo nivel en cada detalle. Elegante, fluido e instalable.",
  land_cap_label: "CAPACIDADES", land_cap_title: "Todo lo que necesitas, nada que te frene",
  land_f1_t: "Impecablemente refinado", land_f1_d: "Una interfaz meticulosamente diseñada donde cada interacción se siente superior.",
  land_f2_t: "Llamadas nítidas", land_f2_d: "Llamadas de audio y video 1:1 y grupales en alta definición, con controles elegantes.",
  land_f3_t: "Asistente IA", land_f3_d: "Usa tus propias claves de Groq / Gemini / OpenRouter. Sugerencias rápidas, dictado por voz, análisis de documentos.",
  land_f4_t: "Stickers y medios", land_f4_d: "Stickers animados, álbumes de imágenes y video, notas de audio y documentos — bellamente presentados.",
  land_f5_t: "Grupos y admins", land_f5_d: "Crea grupos, gestiona miembros y administradores, invitaciones personalizadas con el nombre de quien invita.",
  land_f6_t: "PWA instalable", land_f6_d: "Añade RoyalChat Nova a tu pantalla de inicio en Android e iOS para una verdadera experiencia de app nativa.",
  land_how_label: "CÓMO FUNCIONA", land_how_title: "Diseñado para sentirse sin esfuerzo",
  land_s1_t: "Instala con un toque", land_s1_d: "Añade RoyalChat Nova a tu pantalla de inicio — sin tiendas, sin desorden.",
  land_s2_t: "Conversa con estilo", land_s2_d: "Conversaciones ricas en tiempo real en una elegante interfaz dorada sobre negro.",
  land_s3_t: "Todo en un solo lugar", land_s3_d: "Llamadas, grupos, medios y un asistente IA — todo elegantemente al alcance.",
  land_crafted: "Creado para una experiencia premium",
  land_inside_label: "UN VISTAZO", land_inside_title: "Real por diseño, simple al usar",
  land_mock_chats: "Chats", land_mock_convo: "Conversación", land_mock_ai: "Asistente IA",
  land_mock_talk_soon: "Hablamos pronto 👑", land_mock_design: "Equipo de diseño", land_mock_design_msg: "Kwame: enviado ✅",
  land_mock_mother: "Mamá", land_mock_mother_msg: "Llámame esta noche",
  land_mock_msg1: "Esta app se siente muy premium ✨", land_mock_msg2: "Solo lo mejor para ti 👑",
  land_mock_ai_desc: "Pregunta lo que sea. Resume documentos. Dicta por voz — con tus propias claves.",
  land_install_title: "Instalar RoyalChat Nova", land_install_sub: "Obtén la experiencia completa — icono en pantalla de inicio, modo sin conexión y notificaciones push.",
  land_install_now: "Instalar ahora", land_installed: "Ya instalado",
  land_iphone: "En iPhone (Safari 16.4+)", land_iphone_tap: "toca", land_iphone_add: "Añadir a pantalla de inicio",
  land_nav_features: "Funciones", land_nav_install: "Instalar",
  land_native_apps: "Apps nativas", land_download_on: "Descargar en", land_coming_soon: "PRÓXIMAMENTE",
  land_pillars_label: "UNA APP · DOS MUNDOS", land_pillars_title: "Chatea y conecta — todo en un lugar",
  land_p1_t: "Mensajería y llamadas", land_p1_d: "Chats 1:1 y grupales rápidos, álbumes de medios, notas de voz y llamadas nítidas de audio y video — hechos para funcionar incluso con 4G débil.",
  land_p1_c1: "Grupos", land_p1_c2: "Llamadas", land_p1_c3: "Sin conexión",
  land_p2_t: "Feed social", land_p2_d: "Publica fotos, da me gusta, comenta y comparte. Agrega amigos, sigue personas y mensajéalas en un buzón social separado de tus chats.",
  land_p2_c1: "Amigos", land_p2_c2: "Seguir", land_p2_c3: "Feed",
  land_p3_t: "Mercado", land_p3_d: "Abre una tienda, publica artículos con fotos y precio, impulsa anuncios y recibe mensajes de compradores — vende en línea o solo exhibe.",
  land_p3_c1: "Tiendas", land_p3_c2: "Deseos", land_p3_c3: "Reseñas",
  land_terms: "Términos y condiciones",
  s_social: "Social", s_feed: "Feed", s_friends: "Amigos", s_inbox: "Buzón", s_me: "Yo",
  s_loading: "Cargando…", s_no_posts: "Aún no hay publicaciones. ¡Sé el primero en compartir! 👑",
  s_friend_added: "Amigo agregado", s_failed: "Falló", s_request_sent: "Solicitud enviada",
  s_requests: "Solicitudes", s_discover: "Descubrir", s_now: "ahora", s_no_friends: "Aún no tienes amigos — ¡descubre personas!",
  s_no_requests: "Sin solicitudes de amistad", s_search_people: "Buscar personas…", s_sent: "Enviada", s_add: "Agregar", s_no_people: "No se encontraron personas",
  s_link_copied: "Enlace copiado", s_check_post: "Mira esta publicación", s_deleted: "Eliminado", s_could_not_delete: "No se pudo eliminar", s_write_comment: "Escribe un comentario…",
  s_could_not_upload: "No se pudo subir la imagen", s_posted: "Publicado 🎉", s_could_not_post: "No se pudo publicar", s_whats_mind: "¿Qué estás pensando?", s_public: "Público", s_post: "Publicar",
  s_could_not_upload_media: "No se pudo subir el archivo", s_add_photo: "Foto", s_add_video: "Video", s_add_audio: "Audio", s_add_document: "Documento", s_document: "Documento",
  s_following: "Siguiendo", s_no_following_posts: "Aún no hay publicaciones de amigos o personas que sigues.", s_reactions: "Reacciones",
  s_like: "Me gusta", s_reply: "Responder", s_replying_to: "Respondiendo a", s_write_reply: "Escribe una respuesta…", s_view_replies: "Ver {n} respuestas", s_hide_replies: "Ocultar respuestas",
  s_read_more: "Leer más", s_read_less: "Mostrar menos", s_views: "vistas", s_share_post: "Compartir publicación…", s_reshare: "Recompartir en mi perfil", s_copy_link: "Copiar enlace",
  s_reshared: "recompartió", s_unfollow: "Dejar de seguir", s_block_user: "Bloquear a este usuario", s_report_post: "Reportar publicación", s_delete_post: "Eliminar publicación",
  s_reshared_toast: "Recompartido en tu perfil", s_user_blocked: "Usuario bloqueado", s_reported: "Publicación reportada — gracias", s_unfollowed: "Dejaste de seguir", s_now_following: "Ahora sigues", s_take_photo: "Cámara", s_followers: "Seguidores", s_select: "Seleccionar", s_select_all: "Seleccionar todo", s_message_selected: "Mensaje ({n})", s_write_message: "Escribe un mensaje…", s_send: "Enviar", s_broadcast_sent: "Enviado a {n} personas", s_no_followers: "Aún no tienes seguidores.", s_no_following: "Aún no sigues a nadie.", s_cancel: "Cancelar",
  go_live: "En vivo", your_story: "Tu historia", live_badge: "EN VIVO", live_now: "está en vivo ahora", s_watch: "Ver", live_starting: "Iniciando tu directo…", live_connecting: "Conectando al directo…", live_ended: "Directo finalizado", live_say_something: "Di algo…", live_cam_fail: "Cámara/micrófono no disponible", live_join_fail: "No se pudo unir al directo", live_cam_switch_fail: "No se puede cambiar de cámara", s_close: "Cerrar",
  live_full: "Este directo está lleno", live_buy: "Comprar", live_now_strip: "En vivo ahora",
  live_schedule_live: "Programar un directo", live_schedule_for_later: "Programar para después", live_when_label: "Fecha y hora", live_upcoming: "Próximos directos", live_notify_me: "Avisarme", live_notifying: "Avisado", live_scheduled_ok: "Directo programado", live_soon_toast: "estará en vivo pronto", live_go_now: "Iniciar ahora", live_when_required: "Elige una fecha y hora", live_cancel_sched_q: "¿Cancelar este directo programado?", live_starts_in: "Empieza en", live_starting_soon: "Empieza pronto", live_title_label: "Título (opcional)", live_title_ph: "¿De qué trata tu directo?", live_max_label: "Máx. de espectadores (opcional)", live_max_ph: "Déjalo vacío para ilimitado", live_pin_product: "Fijar un producto", live_replay_caption: "🔴 Repetición del directo", live_replay_posted: "Repetición publicada en tu feed", live_post_replay_q: "¿Guardar este directo como repetición en tu feed?", live_posting_replay: "Publicando repetición…", live_end_btn: "Finalizar", live_filter_none: "Ninguno", live_filter_soft: "Suave", live_filter_warm: "Cálido", live_filter_cool: "Frío", live_filter_vivid: "Vívido", live_filter_mono: "B&N",
  share: "Compartir", share_to_timeline: "Compartir en mi perfil", share_in_chat: "Enviar en un chat", share_copy_link: "Copiar enlace", share_more: "Más…", share_caption_ph: "Di algo sobre esto…", share_link_copied: "Enlace copiado", share_to_timeline_ok: "Compartido en tu perfil", share_sent: "Enviado", share_join_cta: "Únete a RoyalChat Nova para ver más y contactar al vendedor.", share_join_btn: "Únete a RoyalChat Nova", share_not_found: "Este contenido ya no está disponible.", m_view_product: "Ver producto",
  s_no_messages: "Aún no hay mensajes", s_message_friend: "Mensajea a un amigo desde su perfil", s_message_ph: "Mensaje…",
  s_confirm_delete_social: "¿Eliminar TODOS tus datos sociales (publicaciones, amigos, seguidos, mensajes)? Esto no se puede deshacer.",
  s_social_deleted: "Datos sociales eliminados", s_requested: "Solicitado", s_accept: "Aceptar", s_add_friend: "Agregar amigo", s_back: "Atrás",
  s_posts: "Publicaciones", s_following_label: "Siguiendo", s_follow: "Seguir", s_message: "Mensaje", s_no_posts_yet: "Aún no hay publicaciones",
  s_delete_my_data: "Eliminar mis datos sociales", s_delete_my_data_desc: "Elimina todas tus publicaciones, comentarios, amigos, seguidos y mensajes sociales. Tu cuenta de chat permanece.",
  m_market: "Mercado", m_browse: "Explorar", m_saved: "Guardados", m_my_shop: "Mi tienda", m_inbox: "Buzón",
  m_search_items: "Buscar artículos…", m_all: "Todos", m_no_items: "Aún no hay artículos — ¡abre tu tienda y publica algo!",
  m_no_saved: "Aún no hay guardados — toca el corazón en cualquier artículo",
  m_link_copied: "Enlace copiado", m_saved_wishlist: "Guardado en deseos", m_removed: "Eliminado", m_boosted: "Impulsado", m_message: "Mensaje",
  m_no_buyer_msgs: "Aún no hay mensajes de comprador/vendedor", m_message_seller_from: "Mensajea a un vendedor desde cualquier artículo", m_message_seller_ph: "Mensajea al vendedor…",
  m_add_title: "Añade un título", m_updated: "Actualizado", m_listed: "Publicado", m_could_not_save: "No se pudo guardar", m_upload_failed: "Fallo al subir",
  m_edit_item: "Editar artículo", m_list_item: "Publicar un artículo", m_title: "Título", m_price: "Precio", m_description: "Descripción",
  m_category: "Categoría", m_select: "Elegir…", m_location: "Ubicación", m_add_photos: "Añadir fotos", m_take_photo: "Cámara", m_photos_left: "fotos restantes", m_photos_full: "Máximo de 5 fotos alcanzado", m_save_changes: "Guardar cambios", m_publish: "Publicar artículo",
  m_ph_title: "ej. Canasta artesanal", m_ph_category: "Hogar", m_ph_location: "Kigali",
  m_loading: "Cargando…", m_saved_toast: "Guardado", m_pick_star: "Elige una calificación", m_thanks_review: "¡Gracias por tu reseña!",
  m_contact_price: "Precio a consultar", m_seller: "Vendedor", m_ratings_reviews: "Calificaciones y reseñas", m_rate_shop: "Califica esta tienda",
  m_write_review: "Escribe una reseña (opcional)", m_submit_review: "Enviar reseña", m_you_rated: "Calificaste esta tienda", m_no_reviews: "Aún no hay reseñas.", m_message_seller: "Mensajear al vendedor",
  m_name_shop: "Nombra tu tienda", m_shop_saved: "Tienda guardada", m_confirm_delete_shop: "¿Eliminar tu tienda y todos sus artículos? Esto no se puede deshacer.",
  m_shop_deleted: "Tienda eliminada", m_moved_archive: "Movido al archivo", m_reposted: "Republicado por 30 días",
  m_confirm_remove_item: "¿Eliminar este artículo permanentemente de la base de datos?", m_promoted: "¡Promocionado en tu feed social! 🎉", m_could_not_promote: "No se pudo promocionar",
  m_could_not_boost: "No se pudo iniciar el impulso", m_plan_updated: "Plan actualizado", m_could_not_checkout: "No se pudo iniciar el pago",
  m_edit_shop: "Editar tienda", m_open_shop: "Abre tu tienda", m_shop_name: "Nombre de la tienda", m_what_sell: "¿Qué vendes?", m_shop_location: "Ubicación (ej. Kigali)",
  m_subscribe_to_sell: "Suscríbete a un plan de venta abajo para vender en línea", m_just_display: "Solo exhibir", m_sell_online_locked: "Vender en línea 🔒", m_sell_online: "Vender en línea",
  m_plan_lets_sell: "Tu plan te permite vender en línea.", m_selling_requires: "Vender requiere un plan de pago (ver abajo). Exhibir es gratis.",
  m_save_shop: "Guardar tienda", m_selling_online: "Vendiendo en línea", m_display_only: "Solo exhibición", m_starter: "Inicial",
  m_add_item: "Añadir artículo", m_delete: "Eliminar", m_plans_title: "PLANES (POR TAMAÑO DE TIENDA)", m_up_to: "Hasta", m_items_suffix: "artículos",
  m_can_sell: "puede vender en línea", m_display_only_low: "solo exhibición", m_per_mo: "/mes", m_free: "Gratis", m_current: "Actual", m_subscribe: "Suscribirse", m_choose: "Elegir",
  m_my_items: "Mis artículos", m_dashboard: "Panel", m_active_items: "Artículos activos", m_archived: "Archivados", m_total_views: "Vistas totales", m_messages: "Mensajes",
  m_item_views_7d: "Vistas de artículos (últimos 7 días)", m_buyer_msgs_7d: "Mensajes de compradores (últimos 7 días)", m_boost: "Impulsar", m_promote: "Promocionar", m_edit: "Editar", m_repost: "Republicar", m_no_items_yet: "Aún no hay artículos",
  m_boost_item: "Impulsar este artículo", m_boost_desc_1: "Fija", m_boost_desc_2: "en la parte superior de Explorar. Elige una duración:", m_days: "días", m_no_boost_opts: "Aún no hay opciones de impulso.", m_cancel: "Cancelar",
  a_dashboard: "Panel de admin", a_overview: "Resumen", a_users: "Usuarios", a_broadcast: "Difusión", a_feedback: "Comentarios", a_media: "Medios", a_market: "Mercado", a_terms: "Términos", a_cleanup: "Limpieza", a_permissions: "Permisos por sección",
  a_messages: "Mensajes", a_online: "En línea", a_open_feedback: "Comentarios abiertos", a_msgs_day: "Mensajes / día (14d)", a_newusers_day: "Nuevos usuarios / día (14d)", a_storage: "Almacenamiento", a_database: "Base de datos", a_media_files: "Archivos de medios",
  a_set_new_pw: "Establecer nueva contraseña", a_new_pw_ph: "Nueva contraseña (mín. 6 caracteres)", a_save: "Guardar",
  a_broadcast_desc_1: "Enviado desde", a_broadcast_desc_2: "a todos los usuarios. No pueden responder.", a_announcement_ph: "Tu anuncio…", a_remove: "quitar", a_image: "Imagen", a_file: "Archivo",
  a_no_feedback: "Aún no hay comentarios", a_answered: "respondido", a_reply_ph: "Tu respuesta (de RoyalChat Nova)…", a_send: "Enviar", a_respond: "Responder", a_delete: "Eliminar", a_deleted: "Eliminado",
  a_media_desc: "Almacenamiento de medios por área. Elimina un área completa para liberar espacio.", a_loading: "Cargando…", a_chat_media: "Medios de chat", a_social_media: "Medios sociales", a_market_media: "Medios del mercado", a_files: "archivos",
  a_currency: "Moneda", a_platform_fee: "Comisión de plataforma (%)", a_tax_percent: "Impuesto de venta (%)", a_sub_tiers: "NIVELES DE SUSCRIPCIÓN (POR TAMAÑO)", a_max_items: "Máx. artículos", a_price_mo: "Precio /mes", a_can_sell_paid: "Puede vender en línea (función de pago)",
  a_listings_boost: "ANUNCIOS E IMPULSO", a_listing_duration: "Duración del anuncio (días antes de expirar)", a_boost_opts: "Opciones de impulso (fijar un artículo arriba en Explorar)", a_days: "Días", a_price: "Precio",
  a_categories: "CATEGORÍAS", a_cat_desc: "Lista separada por comas para el filtro de compradores", a_save_market: "Guardar ajustes del mercado", a_sellers_shops: "VENDEDORES / TIENDAS", a_items: "artículos", a_subscribed: "suscrito", a_unverify: "Quitar verificación", a_verify: "Verificar", a_no_shops: "Aún no hay tiendas",
  a_terms_desc: "Edita los Términos y condiciones mostrados a los usuarios (Chat, Social y Mercado). Estilo Markdown: usa # y ## para títulos.", a_save_terms: "Guardar términos",
  a_free_space: "Liberar espacio ahora", a_what_delete: "Qué eliminar", a_select_all: "Seleccionar todo", a_clear: "Limpiar", a_images: "imágenes", a_videos: "videos", a_audio: "audio", a_documents: "documentos",
  a_scope: "Alcance", a_older_than: "Más antiguo que…", a_delete_all: "Eliminar todo", a_delete_older_days: "Eliminar elementos más antiguos que (días)", a_delete_all_warn: "⚠️ Esto elimina permanentemente cada elemento seleccionado, sin importar su antigüedad. No se puede deshacer.",
  a_also_delete_files: "También eliminar archivos almacenados (libera más espacio)", a_running: "Ejecutando…", a_delete_all_now: "Eliminar todo lo seleccionado ahora", a_run_cleanup: "Ejecutar limpieza ahora",
  a_sched_cleanup: "Limpieza programada (diaria)", a_autodelete_days: "Autoeliminar más antiguo que (días)", a_save_schedule: "Guardar programación", a_custom_invite: "Mensaje de invitación personalizado", a_save_message: "Guardar mensaje",
  a_load_failed: "Fallo al cargar admin", a_failed: "Falló", a_market_saved: "Ajustes del mercado guardados", a_terms_saved: "Términos guardados", a_verified: "Verificado", a_unverified: "No verificado", a_updated: "Actualizado",
  a_delete_user_q: "¿Eliminar usuario?", a_pw_min: "La contraseña debe tener al menos 6 caracteres", a_pw_updated: "Contraseña actualizada", a_pw_fail: "No se pudo actualizar la contraseña", a_upload_failed: "Fallo al subir",
  a_reply_sent: "Respuesta enviada", a_pick_category: "Elige al menos una categoría para eliminar", a_schedule_saved: "Programación guardada", a_invite_saved: "Mensaje de invitación guardado",
  a_confirm_del_media: "¿Eliminar TODOS los archivos de medios de esta área? No se puede deshacer.", a_files_deleted: "archivos eliminados", a_confirm_cleanup: "¿Eliminar los medios seleccionados? No se puede deshacer.", a_removed: "Eliminado", a_sent_broadcast: "Difusión enviada",
  ss_title: "Ajustes sociales", ss_desc: "Eliminar automáticamente mis publicaciones después de un tiempo. Mantiene tu feed ordenado — solo afecta tus propias publicaciones.", ss_saved: "Guardado",
  ss_never: "Nunca (guardar para siempre)", ss_1m: "Tras 1 mes", ss_3m: "Tras 3 meses", ss_6m: "Tras 6 meses", ss_12m: "Tras 12 meses",
  set_available: "Disponible en RoyalChat Nova", set_invite_title: "Invitar amigos", set_invite_desc: "Comparte RoyalChat Nova con tus contactos",
  set_suggest_title: "Enviar una sugerencia", set_suggest_desc: "Ayúdanos a mejorar — adjunta una captura", set_away_title: "Alertas de correo por ausencia",
  set_social_market: "SOCIAL Y MERCADO", set_social_title: "Ajustes sociales", set_social_desc: "Autoeliminar publicaciones antiguas y más",
  set_market_title: "Ajustes del mercado", set_market_desc: "Gestiona tu tienda, artículos y panel", set_terms_title: "Términos y condiciones", set_terms_desc: "Chat, Social y Mercado",
  set_installed: "App instalada", set_installed_toast: "Instalada ✓", set_ios_install: "Safari: Compartir → Añadir a pantalla de inicio", set_browser_install: "Menú del navegador → Instalar app",
  set_not_supported: "No compatible con este dispositivo", set_notif_fail: "No se pudieron activar las notificaciones",
  m_photos_max: "Fotos (hasta 5)", m_add_video: "Añadir video", m_video: "Video de presentación", m_remove_video: "Quitar video",
  m_stock_label: "Cantidad en stock", m_stock_ph: "Déjalo vacío para ilimitado", m_variants: "Variantes (Color, Talla…)",
  m_add_option: "Añadir opción", m_option_name_ph: "Nombre de opción (ej. Color)", m_option_values_ph: "Valores separados por comas (ej. Rojo, Azul)", m_variant_stock: "Stock por opción",
  m_promo: "Promoción", m_promo_price: "Precio promo", m_promo_days: "La promo dura (días)", m_off: "DESC.", m_ends_in: "Termina en", m_day_short: "d",
  m_out_of_stock: "Agotado", m_only_left: "Solo quedan {n}", m_in_stock: "En stock", m_qty: "Cant.", m_more_from_shop: "Más de esta tienda",
  m_visit_shop: "Visitar tienda", m_select_options: "Selecciona opciones",
  m_shop_avatar: "Avatar de tienda (pequeño)", m_shop_banner: "Banner de tienda (grande)", m_upload_photo: "Subir", m_change_photo: "Cambiar",
  m_featured_shops: "Tiendas destacadas", m_recently_viewed: "Vistos recientemente", m_shop_items: "Artículos", m_shop_no_items: "Esta tienda aún no tiene artículos",
  m_cart: "Carrito", m_add_to_cart: "Añadir al carrito", m_added_to_cart: "Añadido al carrito", m_cart_empty: "Tu carrito está vacío", m_cart_empty_hint: "Explora artículos y agrégalos aquí",
  m_subtotal: "Subtotal", m_tax: "Impuesto", m_total: "Total", m_checkout: "Pagar", m_remove: "Quitar", m_choose_options_first: "Selecciona opciones primero", m_processing: "Procesando…", m_each: "c/u",
  st_new_story: "Nueva historia", st_camera: "Cámara", st_camera_sub: "Foto o video", st_gallery: "Galería", st_gallery_sub: "Subir del dispositivo", st_text: "Texto", st_text_sub: "Escribir sobre un fondo",
  st_type_something: "Escribe algo…", st_sticker: "Sticker", st_poll: "Encuesta", st_ask: "Pregunta", st_link: "Enlace", st_draw: "Dibujar", st_music: "Música",
  st_undo: "Deshacer", st_clear: "Borrar", st_done: "Listo", st_add_caption: "Añadir un texto…", st_public: "Público", st_friends: "Amigos", st_close_friends: "Mejores amigos",
  st_also_share: "Compartir también en el feed", st_post_story: "Publicar historia", st_add_poll: "Añadir encuesta", st_ask_question: "Hacer una pregunta", st_add_link: "Añadir enlace",
  st_question_opt: "Pregunta (opcional)", st_option1: "Opción 1", st_option2: "Opción 2", st_ask_me: "Pregúntame lo que sea", st_btn_label: "Texto del botón (opcional)",
  st_cancel: "Cancelar", st_add: "Añadir", st_visit_link: "Ver enlace", st_uploading: "Subiendo…", st_upload_own: "Sube la tuya",
  st_your_story: "Tu historia", st_views: "vistas", st_view: "vista", st_reply_to: "Responder a", st_insights: "Estadísticas", st_story_insights: "Estadísticas de la historia",
  st_replies: "Respuestas", st_reactions: "Reacciones", st_no_answers: "Aún sin respuestas", st_viewers: "vistas", st_no_viewers: "Aún sin vistas",
  st_replies_in_insights: "Las respuestas aparecen en tus estadísticas", st_sent: "Enviado ✨", st_type_short: "Escribe…",
  st_new_highlight: "Nueva destacada", st_hl_name_ph: "Nombre (ej. Viaje, Familia)", st_hl_cover_hint: "Toca el círculo para elegir una portada (opcional — si no, se usa la primera historia).",
  st_hl_choose: "Elige las historias a incluir", st_hl_selected: "seleccionada(s)", st_hl_none: "Aún no tienes historias. Publica una y luego guárdala aquí.",
  st_save_highlight: "Guardar destacada", st_new: "Nueva", st_edit: "Editar",
  st_story_posted: "Historia publicada ✨", st_post_failed: "No se pudo publicar la historia", st_music_added: "Música añadida 🎵", st_upload_failed: "Error al subir",
  st_two_options: "Añade dos opciones", st_enter_url: "Escribe una URL", st_hl_saved: "Destacada guardada ⭐", st_pick_story: "Elige al menos una historia",
  st_cover_failed: "Error al subir la portada", st_hl_deleted: "Destacada eliminada", st_cover_updated: "Portada actualizada", st_order_saved: "Orden guardado", st_failed: "Error",
  st_reply_sent: "Respuesta enviada", st_story_deleted: "Historia eliminada", st_empty_highlight: "Esta destacada está vacía", st_delete_story_q: "¿Eliminar esta historia?", st_delete_hl_q: "¿Eliminar esta destacada?",
  call_voice: "Llamada de voz", call_video: "Videollamada", call_missed_voice: "Llamada de voz perdida", call_missed_video: "Videollamada perdida",
  call_failed: "Llamada fallida", call_no_answer: "Sin respuesta", call_try_again: "Reintentar", call_tap_back: "Toca para devolver la llamada", call_min: "min", call_sec: "s",
  call_lbl_mute: "Silenciar", call_lbl_unmute: "Activar", call_lbl_speaker: "Altavoz", call_lbl_headset: "Auriculares", call_lbl_camera: "Cámara", call_lbl_flip: "Girar", call_lbl_saver: "Ahorro datos", call_lbl_end: "Colgar", call_lbl_answer: "Responder", call_lbl_decline: "Rechazar", call_lbl_fullscreen: "Pantalla completa", call_lbl_normal: "Normal",

  // --- Completed translations (auto-added) ---
  m_pick_category_shop: "Elige una categoría para tu tienda",
  m_add_location_shop: "Añade la ubicación de tu tienda",
  m_shop_ready: "Tu tienda está {n}% lista",
  m_banner_hint: "Banner — 1200×400px es lo ideal",
  m_avatar_hint: "Logo — cuadrado, 400×400px queda mejor",
  m_currency: "Moneda",
  m_shop_location_short: "Ubicación",
  m_see_plans: "Ver planes",
  m_plans_save_first: "Guarda tu tienda primero, luego suscríbete a un plan de venta.",
  m_almost_there: "Casi listo — solo añade: {fields}",
  m_golive_desc: "Transmite en vivo a tus compradores — próximamente",
  m_report_chat: "Reportar al admin",
  m_report_desc: "Reporta tu chat con {name} al equipo de RoyalChat Nova. Lo revisarán.",
  m_report_reason_ph: "¿Qué ocurre? (opcional) — ej. te pidió pagar fuera de la app",
  m_report_submit: "Reportar al admin",
  m_report_sent: "Reportado al admin — gracias",
  m_reason_offapp: "Pidió pagar fuera de la app",
  m_reason_fake: "Artículo falso / estafa",
  m_reason_noshow: "No se presentó / no entregó",
  m_reason_harassment: "Acoso",
  m_reason_other: "Otra cosa",
  m_text_seller: "Escribir al vendedor",
  m_sales: "Ventas",
  m_no_sales: "Aún no hay ventas",
  m_paid: "Pagado",
  m_refunded: "Reembolsado",
  m_sale_total: "Total de venta",
  m_commission: "Comisión",
  m_you_receive: "Recibes",
  m_refund_buyer: "Reembolsar comprador",
  m_confirm_refund: "¿Reembolsar a este comprador? No se puede deshacer.",
  m_refund_issued: "Reembolso emitido",
  m_payout_saved: "Datos de cobro guardados — ya puedes vender",
  m_payout_ready: "El dinero va a {method}",
  m_payout_needed: "Añade dónde recibirás el dinero para empezar a vender",
  m_sell_pending: "Venta pendiente — completa la configuración de cobros",
  m_payout_active: "Cobros activos",
  m_payout_receive_at: "Recibes el dinero en",
  m_payout_incomplete: "Configuración de cobros incompleta",
  m_selling_pending_short: "Vendiendo (cobro pendiente)",
  m_payout_title: "Datos de cobro",
  m_payout_receive_note: "Aquí es donde RECIBIRÁS el dinero de tus ventas — no se te cobra nada.",
  m_payout_card: "Tarjeta",
  m_payout_bank: "Banco",
  m_payout_card_name: "Nombre del titular",
  m_payout_card_number: "Número de tarjeta",
  m_payout_exp: "Vencimiento",
  m_payout_cvv: "CVV",
  m_payout_acct_name: "Nombre del titular de la cuenta",
  m_payout_bank_name: "Nombre del banco",
  m_payout_acct_number: "Número de cuenta",
  m_payout_routing: "Código de ruta / sucursal",
  m_payout_save: "Guardar y empezar a vender",
  m_payout_secure_note: "Solo guardamos una referencia enmascarada (ej. •••• 4242). Los cobros reales se activan al conectar un proveedor.",
  m_payout_fill: "Completa todos los campos",
  m_payout_fail: "No se pudieron guardar los datos de cobro",
  m_payout_after_save: "Guarda tu tienda y luego añade los datos de cobro para empezar a vender.",
  m_lifetime_net: "Ganancias totales",
  m_this_month: "Este mes",
  m_mark_shipped: "Marcar enviado",
  m_mark_delivered: "Marcar entregado",
  m_marked_shipped: "Marcado como enviado — comprador notificado",
  m_marked_delivered: "Marcado como entregado — comprador notificado",
  m_fs_processing: "Preparando",
  m_fs_shipped: "Enviado",
  m_fs_delivered: "Entregado",
  m_orders: "Pedidos",
  m_no_orders: "Aún no hay pedidos",
  m_track_processing: "Preparando",
  m_track_shipped: "Enviado",
  m_track_delivered: "Entregado",
  m_track_refunded: "Reembolsado",
  m_sell_coming_soon: "¡La venta en línea llegará pronto — espera un poco!",
  a_currency_note: "Ahora los vendedores eligen la moneda de su tienda. Las tarifas, impuestos y precios de planes se facturan en USD.",
  a_reports: "Reportes",
  a_no_reports: "Sin reportes del mercado 🎉",
  a_report: "Reporte",
  a_warned: "Advertido",
  a_seller_suspended: "Vendedor suspendido",
  a_dismissed: "Descartado",
  a_seller: "Vendedor",
  a_user_gone: "cuenta eliminada",
  a_item: "Artículo",
  a_reason: "Motivo",
  a_no_reason: "Sin motivo indicado",
  a_reported_by: "Reportado por",
  a_warn: "Advertir",
  a_unsuspend: "Reactivar",
  a_suspend: "Suspender",
  a_dismiss: "Descartar",
  a_confirm_suspend: "¿Suspender a este vendedor? Su tienda y artículos se ocultarán y quedará bloqueado hasta reactivarlo.",
  a_warn_sent: "Advertencia enviada al vendedor",
  a_suspended_ok: "Vendedor suspendido",
  a_unsuspended_ok: "Vendedor reactivado",
  a_dismissed_ok: "Reporte descartado",
  a_commission: "Comisión de plataforma (%)",
  a_commission_note: "La comisión se toma de cada venta del lado del vendedor — los compradores siempre pagan el precio indicado.",
  a_payout_setup: "Configuración de cobros del vendedor",
  a_sell_shops: "Tiendas con venta",
  a_payout_done: "Cobro listo",
  a_payout_pending: "Pendiente",
  a_welcome_title: "Mensaje de bienvenida",
  a_welcome_desc: "Enviado automáticamente por RoyalChat Nova a cada usuario en el momento en que se registra.",
  a_welcome_from: "Enviado como",
  a_welcome_lang_hint: "Elige un idioma y luego edita el mensaje que verán los usuarios registrados en ese idioma. Los idiomas que dejes en blanco usarán el inglés.",
  a_welcome_saved: "Mensaje de bienvenida guardado",
  a_on: "Activado",
  a_off: "Desactivado",
};

export const ar = {
  safe_trade_title: "تداول بأمان", safe_trade_dismiss: "حسناً",
  safe_tip_1: "للصفقات المحلية، التقيا في مكان عام مزدحم.",
  safe_tip_2: "افحص السلعة شخصياً قبل الدفع.",
  safe_tip_3: "لا تدفع مقدماً أبداً ولا تشارك رموز OTP / البطاقة / PIN.",
  safe_tip_4: "إذا بدا السعر جيداً لدرجة يصعب تصديقها، فكن حذراً.",
  scam_warning: "شروط دفع خطِرة. لا تدفع مقدماً ولا تشارك أي رموز.",
  scam_compose_warning: "يبدو هذا محفوفاً بالمخاطر. حافظ على سلامتك — تجنّب الدفع المسبق ومشاركة الرموز.",
  photo_tips: "نصائح التصوير", photo_tips_title: "الصور الجيدة تُباع أسرع",
  photo_tip_1: "صوّر في ضوء طبيعي ساطع.",
  photo_tip_2: "أظهر السلعة من عدة زوايا.",
  photo_tip_3: "استخدم خلفية نظيفة وخالية من الفوضى.",
  photo_tip_4: "أظهر أي عيوب بصدق لبناء الثقة.",
  photo_tip_5: "املأ الإطار — اقترب من السلعة.",
  help_guide: "دليل", guide_got_it: "حسناً", coming_soon: "قريباً",
  guide_social_title: "التنقّل في القسم الاجتماعي",
  guide_social_1: "الموجز — منشورات الأصدقاء ومن تتابعهم. بدّل إلى اكتشاف.",
  guide_social_2: "الأصدقاء — ابحث عن أشخاص واقبل الطلبات واكتشف مستخدمين.",
  guide_social_3: "الوارد — رسائل خاصة، الآن مع الصور والفيديو والملاحظات الصوتية.",
  guide_social_4: "أنا — ملفك ومنشوراتك وإحصاءاتك. قائمة ⋯ للمتابعة أو المشاركة أو الإبلاغ.",
  guide_market_title: "التنقّل في السوق",
  guide_market_1: "تصفّح — ابحث عن السلع واضغط على البطاقة لرؤية التفاصيل.",
  guide_market_2: "المحفوظات — السلع التي أعجبتك لاحقاً.",
  guide_market_3: "متجري — أدرج السلع وأطلق العروض وأدر متجرك.",
  guide_market_4: "الوارد — راسِل المشترين أو البائعين. ابحث عن شارة البائع الموثّق الذهبية ✔.",
  open_app: "افتح التطبيق", get_started: "ابدأ", install: "ثبّت RoyalChat Nova", download_royalchat: "تنزيل RoyalChat Nova",
  login: "تسجيل الدخول", register: "إنشاء حساب", email: "البريد الإلكتروني", password: "كلمة المرور",
  name: "الاسم الكامل", chats: "الرسائل", search: "بحث في المحادثات…", new_chat: "محادثة جديدة",
  settings: "الإعدادات", logout: "تسجيل الخروج", type_message: "اكتب رسالة…",
  pinned: "المثبتة", all_chats: "كل المحادثات", online: "متصل", typing: "يكتب…",
  pin: "تثبيت", schedule: "جدولة",
  no_chats: "لا توجد محادثات بعد", start_conversation: "ابدأ محادثة",
  profile: "الملف الشخصي", theme: "المظهر", language: "اللغة", dark: "داكن", light: "فاتح",
  ai_assistant: "المساعد الذكي", admin: "المشرف", read_aloud: "قراءة بصوت عالٍ",
  admin_panel_desc: "إدارة المستخدمين والوسائط والبث",
  tab_chats: "محادثات", tab_calls: "مكالمات", tab_settings: "إعدادات", tab_social: "اجتماعي", tab_market: "المتجر",
  appearance: "المظهر", preferences: "التفضيلات", network: "الشبكة", connected: "متصل",
  notifications: "الإشعارات", edit_profile: "تعديل الملف الشخصي", phone: "رقم الهاتف",
  data_usage: "استهلاك البيانات", used_today: "مستخدمة اليوم",
  country: "الدولة", about: "حول", change_password: "تغيير كلمة المرور", save: "حفظ", cancel: "إلغاء",
  pw_current: "كلمة المرور الحالية", pw_new: "كلمة المرور الجديدة", pw_update: "تحديث", pw_updated: "تم تحديث كلمة المرور ✓", pw_fill_both: "أدخل كلمة المرور الحالية والجديدة", pw_too_short: "يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل", pw_change_failed: "تعذّر تغيير كلمة المرور",
  auto_download: "التنزيل التلقائي للوسائط", auto_download_desc: "اختر الوسائط التي تُنزَّل تلقائياً", mt_images: "الصور", mt_audio: "الصوت", mt_video: "الفيديو", mt_documents: "المستندات",
  clear_media_title: "مسح الوسائط المخزَّنة؟", clear_media_warn: "سيؤدي هذا إلى حذف جميع الصور والفيديوهات والملفات الصوتية والمستندات المُنزَّلة على هذا الجهاز نهائياً. سيُعاد تنزيلها عند فتحها مرة أخرى.", clear_media_confirm: "مسح",
  welcome_back: "مرحبًا بعودتك", signin_continue: "سجّل الدخول لمتابعة محادثاتك.",
  join_royalchat: "انضم إلى RoyalChat Nova", create_seconds: "أنشئ حسابك في ثوانٍ.",
  forgot_password: "نسيت كلمة المرور؟", new_here: "جديد على RoyalChat Nova؟", already_account: "لديك حساب بالفعل؟",
  email_or_phone: "البريد الإلكتروني أو رقم الهاتف", continue_google: "المتابعة عبر Google", or_divider: "أو",
  search_country: "ابحث عن دولة…", no_results: "لا نتائج", today: "اليوم", yesterday: "أمس",
  create_account_cta: "إنشاء الحساب", login_tagline: "حيث تصبح المحادثات ملكية",
  reply: "رد", you: "أنت", copy: "نسخ", delete: "حذف", open: "فتح", download: "تنزيل", copied: "تم النسخ",
  forward: "إعادة توجيه", forward_to: "إعادة توجيه إلى", forwarded: "أُعيد توجيهه", this_chat: "هذه المحادثة",
  block: "حظر", unblock: "إلغاء الحظر",
  land_badge: "تجربة مراسلة فاخرة", land_hero_1: "حيث تشعر كل محادثة أنها", land_hero_accent: "من الدرجة الأولى",
  land_nav_features: "المميزات", land_nav_install: "تثبيت", land_terms: "الشروط والأحكام",
  land_pillars_title: "دردش وتواصل — كل ذلك في مكان واحد",
  land_p1_t: "المراسلة والمكالمات", land_p2_t: "الخلاصة الاجتماعية", land_p3_t: "المتجر",
  s_social: "اجتماعي", s_feed: "الخلاصة", s_friends: "الأصدقاء", s_inbox: "الوارد", s_me: "أنا",
  s_loading: "جارٍ التحميل…", s_no_posts: "لا منشورات بعد. كن أول من يشارك! 👑",
  s_friends_added: "تمت الإضافة", s_failed: "فشل", s_request_sent: "أُرسل الطلب",
  s_requests: "الطلبات", s_discover: "اكتشف", s_now: "الآن", s_search_people: "ابحث عن أشخاص…", s_add: "إضافة", s_sent: "أُرسل",
  s_like: "إعجاب", s_reply: "رد", s_write_comment: "اكتب تعليقًا…", s_write_reply: "اكتب ردًا…",
  s_read_more: "قراءة المزيد", s_read_less: "عرض أقل", s_views: "مشاهدات", s_post: "نشر", s_whats_mind: "بماذا تفكر؟",
  s_add_photo: "صورة", s_add_video: "فيديو", s_add_audio: "صوت", s_add_document: "مستند", s_take_photo: "الكاميرا",
  s_following: "المتابَعون", s_follow: "متابعة", s_unfollow: "إلغاء المتابعة", s_now_following: "تتابع الآن", s_message: "رسالة", s_send: "إرسال",
  s_followers: "المتابِعون", s_posts: "المنشورات", s_following_label: "يتابع", s_back: "رجوع", s_cancel: "إلغاء",
  s_share_post: "مشاركة المنشور…", s_copy_link: "نسخ الرابط", s_delete_post: "حذف المنشور", s_report_post: "الإبلاغ عن المنشور",
  go_live: "بث مباشر", your_story: "قصتك", live_badge: "مباشر", live_now: "يبث الآن", s_watch: "مشاهدة", live_ended: "انتهى البث",
  live_say_something: "قل شيئًا…", live_now_strip: "مباشر الآن", live_full: "البث ممتلئ", live_buy: "شراء", s_close: "إغلاق",
  live_schedule_for_later: "جدولة لاحقًا", live_when_label: "التاريخ والوقت", live_upcoming: "بثوث قادمة",
  live_notify_me: "أعلمني", live_notifying: "سيتم إعلامك", live_scheduled_ok: "تمت جدولة البث", live_go_now: "ابدأ الآن",
  live_starts_in: "يبدأ خلال", live_starting_soon: "يبدأ قريبًا", live_title_label: "العنوان (اختياري)",
  live_max_label: "الحد الأقصى للمشاهدين (اختياري)", live_pin_product: "تثبيت منتج", live_end_btn: "إنهاء البث",
  live_filter_none: "بدون", live_filter_soft: "ناعم", live_filter_warm: "دافئ", live_filter_cool: "بارد", live_filter_vivid: "زاهٍ", live_filter_mono: "أبيض وأسود",
  share: "مشاركة", share_to_timeline: "مشاركة على صفحتي", share_in_chat: "إرسال في محادثة", share_copy_link: "نسخ الرابط",
  share_more: "المزيد…", share_link_copied: "تم نسخ الرابط", share_sent: "أُرسل", share_join_btn: "انضم إلى RoyalChat Nova",
  share_join_cta: "انضم إلى RoyalChat Nova لرؤية المزيد والتواصل مع البائع.", share_not_found: "هذا المحتوى لم يعد متاحًا.", m_view_product: "عرض المنتج",
  m_market: "المتجر", m_browse: "تصفّح", m_saved: "المحفوظة", m_my_shop: "متجري", m_inbox: "الوارد",
  m_search_items: "ابحث عن منتجات…", m_all: "الكل", m_message: "رسالة", m_add_to_cart: "أضف إلى السلة", m_added_to_cart: "أُضيف إلى السلة",
  m_title: "العنوان", m_price: "السعر", m_description: "الوصف", m_category: "الفئة", m_location: "الموقع",
  m_list_item: "أضف منتجًا", m_edit_item: "تعديل المنتج", m_publish: "نشر المنتج", m_save_changes: "حفظ التغييرات",
  m_add_photos: "أضف صورًا", m_take_photo: "الكاميرا", m_seller: "البائع", m_message_seller: "مراسلة البائع",
  m_cart: "السلة", m_checkout: "الدفع", m_subtotal: "المجموع الفرعي", m_tax: "الضريبة", m_total: "الإجمالي", m_remove: "إزالة",
  m_visit_shop: "زيارة المتجر", m_in_stock: "متوفر", m_out_of_stock: "غير متوفر", m_qty: "الكمية", m_each: "للوحدة",
  m_edit_shop: "تعديل المتجر", m_shop_name: "اسم المتجر", m_save_shop: "حفظ المتجر", m_add_item: "أضف منتجًا",
  a_dashboard: "لوحة المشرف", a_overview: "نظرة عامة", a_users: "المستخدمون", a_broadcast: "بث", a_feedback: "الملاحظات",
  a_media: "الوسائط", a_market: "المتجر", a_terms: "الشروط", a_cleanup: "تنظيف", a_permissions: "أذونات الأقسام",
  set_social_title: "إعدادات التواصل", set_market_title: "إعدادات المتجر", set_terms_title: "الشروط والأحكام",
  help_support: "المساعدة والدعم", blocked_contacts: "جهات الاتصال المحظورة", verify_email: "تأكيد بريدي",
  st_new_story: "قصة جديدة", st_camera: "الكاميرا", st_camera_sub: "صورة أو فيديو", st_gallery: "المعرض", st_gallery_sub: "رفع من الجهاز", st_text: "نص", st_text_sub: "الكتابة على خلفية",
  st_type_something: "اكتب شيئاً…", st_sticker: "ملصق", st_poll: "استطلاع", st_ask: "سؤال", st_link: "رابط", st_draw: "رسم", st_music: "موسيقى",
  st_undo: "تراجع", st_clear: "مسح", st_done: "تم", st_add_caption: "أضف تعليقاً…", st_public: "عام", st_friends: "الأصدقاء", st_close_friends: "الأصدقاء المقربون",
  st_also_share: "انشر أيضاً في الموجز", st_post_story: "نشر القصة", st_add_poll: "إضافة استطلاع", st_ask_question: "اطرح سؤالاً", st_add_link: "إضافة رابط",
  st_question_opt: "سؤال (اختياري)", st_option1: "الخيار 1", st_option2: "الخيار 2", st_ask_me: "اسألني أي شيء", st_btn_label: "نص الزر (اختياري)",
  st_cancel: "إلغاء", st_add: "إضافة", st_visit_link: "زيارة الرابط", st_uploading: "جارٍ الرفع…", st_upload_own: "ارفع موسيقاك",
  st_your_story: "قصتك", st_views: "مشاهدات", st_view: "مشاهدة", st_reply_to: "الرد على", st_insights: "الإحصاءات", st_story_insights: "إحصاءات القصة",
  st_replies: "الردود", st_reactions: "التفاعلات", st_no_answers: "لا إجابات بعد", st_viewers: "مشاهدون", st_no_viewers: "لا مشاهدات بعد",
  st_replies_in_insights: "تظهر الردود في إحصاءاتك", st_sent: "تم الإرسال ✨", st_type_short: "اكتب…",
  st_new_highlight: "أبرز جديد", st_hl_name_ph: "الاسم (مثل رحلة، عائلة)", st_hl_cover_hint: "اضغط الدائرة لاختيار غلاف مخصص (اختياري — وإلا تُستخدم أول قصة).",
  st_hl_choose: "اختر القصص لإضافتها", st_hl_selected: "محدد", st_hl_none: "ليس لديك قصص بعد. انشر قصة أولاً ثم احفظها هنا.",
  st_save_highlight: "حفظ الأبرز", st_new: "جديد", st_edit: "تعديل",
  st_story_posted: "تم نشر القصة ✨", st_post_failed: "تعذر نشر القصة", st_music_added: "أُضيفت الموسيقى 🎵", st_upload_failed: "فشل الرفع",
  st_two_options: "أضف خيارين", st_enter_url: "أدخل رابطاً", st_hl_saved: "تم حفظ الأبرز ⭐", st_pick_story: "اختر قصة واحدة على الأقل",
  st_cover_failed: "فشل رفع الغلاف", st_hl_deleted: "تم حذف الأبرز", st_cover_updated: "تم تحديث الغلاف", st_order_saved: "تم حفظ الترتيب", st_failed: "فشل",
  st_reply_sent: "تم إرسال الرد", st_story_deleted: "تم حذف القصة", st_empty_highlight: "هذا الأبرز فارغ", st_delete_story_q: "حذف هذه القصة؟", st_delete_hl_q: "حذف هذا الأبرز؟",
  call_voice: "مكالمة صوتية", call_video: "مكالمة فيديو", call_missed_voice: "مكالمة صوتية فائتة", call_missed_video: "مكالمة فيديو فائتة",
  call_failed: "فشلت المكالمة", call_no_answer: "لا يوجد رد", call_try_again: "إعادة المحاولة", call_tap_back: "اضغط لمعاودة الاتصال", call_min: "دقيقة", call_sec: "ثانية",
  call_lbl_mute: "كتم", call_lbl_unmute: "إلغاء الكتم", call_lbl_speaker: "مكبر الصوت", call_lbl_headset: "سماعة", call_lbl_camera: "الكاميرا", call_lbl_flip: "قلب", call_lbl_saver: "توفير البيانات", call_lbl_end: "إنهاء", call_lbl_answer: "رد", call_lbl_decline: "رفض", call_lbl_fullscreen: "ملء الشاشة", call_lbl_normal: "عادي",

  // --- Completed translations (auto-added) ---
  ultra_lite: "الوضع فائق الخفة",
  ultra_lite_desc: "نص فقط: الوسائط عند النقر، وإيقاف معاينات الروابط",
  auto_delete_media: "حذف الوسائط تلقائياً",
  auto_delete_desc: "امسح الوسائط الأقدم من ذلك لتحرير مساحة",
  app_lock: "قفل التطبيق",
  app_lock_desc: "طلب رمز PIN لفتح التطبيق",
  app_lock_on: "مفعّل · يلزم رمز PIN للفتح",
  notifications_on: "الإشعارات مفعّلة",
  notifications_blocked: "الإشعارات محظورة",
  ios_install_for_push: "على iPhone: اضغط مشاركة ← إضافة إلى الشاشة الرئيسية، ثم افتح RoyalChat Nova من شاشتك الرئيسية لتفعيل الإشعارات.",
  or_pick_avatar: "أو اختر صورة رمزية",
  calls: "المكالمات",
  all: "الكل",
  missed: "الفائتة",
  no_calls: "لا مكالمات بعد",
  configure_ai: "إعداد الذكاء الاصطناعي",
  get_free_key: "احصل على مفتاح مجاني",
  how_get_key: "كيفية الحصول على مفتاحك (دقيقة واحدة، دون بطاقة)",
  reset_pw_title: "إعادة تعيين كلمة المرور",
  reset_pw_desc: "أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين.",
  send_reset: "إرسال رابط إعادة التعيين",
  back_login: "العودة لتسجيل الدخول",
  back_home: "العودة للرئيسية",
  readonly_notice: "هذه قناة رسمية من RoyalChat Nova — لا يمكنك الرد هنا.",
  channel_readonly_notice: "يمكن للمشرفين فقط النشر في هذه القناة.",
  create_account_title: "أنشئ\nحسابك",
  create_account_sub: "انضم إلى RoyalChat Nova وابدأ الدردشة",
  complete_profile_prompt: "أضف دولتك ورقم هاتفك ليتمكن الأصدقاء من إيجادك والاتصال بك.",
  complete_profile_cta: "أكمل الملف الشخصي",
  dismiss: "تجاهل",
  remove_key: "إزالة المفتاح",
  key_removed: "تمت إزالة المفتاح",
  attach_photos: "صور",
  attach_document: "مستند",
  attach_sticker: "ملصق",
  attach_camera: "كاميرا",
  poll: "استطلاع",
  read_receipts: "إيصالات القراءة",
  read_receipts_desc: "إظهار العلامات الزرقاء عند قراءتك للرسائل",
  sending_tap_cancel: "جارٍ الإرسال… اضغط للإلغاء",
  recording: "جارٍ التسجيل…",
  data_storage: "البيانات والتخزين",
  data_saver: "موفّر البيانات",
  data_saver_desc: "ضغط الصور والصوت والفيديو بقوة",
  autodl_off: "أبداً",
  autodl_wifi: "Wi-Fi فقط",
  autodl_always: "دائماً",
  undo_send_title: "التراجع قبل الإرسال",
  undo_send_desc: "تأخير الرسائل حتى تتمكن من الإلغاء",
  storage_cleanup: "مسح الوسائط المخزَّنة",
  storage_cleanup_desc: "إزالة الصور والصوت والمستندات المحفوظة على هذا الجهاز",
  storage_cleared: "تم مسح التخزين",
  help_support_desc: "الأسئلة الشائعة وكيفية الحصول على المساعدة",
  privacy_help: "الخصوصية والمساعدة",
  sounds_ringtones: "الأصوات والنغمات",
  sound_effects: "المؤثرات الصوتية",
  sound_effects_desc: "تشغيل نغمات للإرسال والاستقبال والمكالمات",
  tone_sent: "رسالة مُرسلة",
  tone_received: "رسالة مستلمة",
  tone_call: "مكالمة واردة",
  verified: "موثّق",
  not_verified: "غير موثّق",
  verify_email_desc: "احصل على شارة توثيق على حسابك",
  verify_intro: "سنرسل رمزاً من 6 أرقام إلى بريدك للتأكد أنه أنت.",
  verify_send_code: "إرسال الرمز",
  verify_enter_code: "أدخل الرمز المكوّن من 6 أرقام الذي أرسلناه لبريدك",
  verify_confirm: "توثيق البريد",
  verify_success: "تم توثيق البريد",
  verify_code_sent: "أُرسل الرمز إلى بريدك",
  verify_invalid: "رمز غير صالح أو منتهٍ",
  verify_resend: "إعادة إرسال الرمز",
  already_verified: "بريدك موثّق",
  blocked_contacts_desc: "أدِر الأشخاص الذين حظرتهم",
  no_blocked: "لم تحظر أحداً",
  block_contact: "حظر جهة الاتصال",
  blocked_toast: "تم حظر جهة الاتصال",
  unblocked_toast: "تم إلغاء حظر جهة الاتصال",
  tap_to_download: "اضغط للتنزيل",
  poor_connection_quality: "اتصال ضعيف · جودة منخفضة",
  call_reconnecting: "جارٍ إعادة الاتصال…",
  messages_label: "رسائل",
  one_message_label: "رسالة واحدة",
  forwarded_label: "مُعاد توجيهه",
  load_older: "تحميل الرسائل الأقدم",
  loading_older: "جارٍ التحميل…",
  jump_to_latest: "الانتقال إلى الأحدث",
  land_hero_sub: "تطبيق مراسلة مصمَّم بإتقان — مكالمات راقية، ومساعد ذكي، وتجربة من الطراز الأول في كل تفصيل. أنيق وسلس وقابل للتثبيت.",
  land_cap_label: "الإمكانات",
  land_cap_title: "كل ما تحتاجه، دون أي بطء",
  land_f1_t: "أناقة لا تشوبها شائبة",
  land_f1_d: "واجهة مصمَّمة بعناية فائقة، كل تفاعل فيها يبدو من طبقة أرقى.",
  land_f2_t: "مكالمات فائقة الوضوح",
  land_f2_d: "مكالمات صوت وفيديو فردية وجماعية عالية الدقة مع أدوات تحكّم أنيقة.",
  land_f3_t: "المساعد الذكي",
  land_f3_d: "استخدم مفاتيحك من Groq / Gemini / OpenRouter. أوامر سريعة، وإملاء صوتي، وتحليل مستندات.",
  land_f4_t: "الملصقات والوسائط",
  land_f4_d: "ملصقات متحركة، وألبومات صور وفيديو، وملاحظات صوتية ومستندات — بعرض جميل.",
  land_f5_t: "المجموعات والمشرفون",
  land_f5_d: "أنشئ مجموعات، وأدِر الأعضاء والمشرفين، ودعوات مخصَّصة باسم من يدعو.",
  land_f6_t: "تطبيق ويب قابل للتثبيت",
  land_f6_d: "أضف RoyalChat Nova إلى شاشتك الرئيسية على Android وiOS لتجربة تطبيق أصلي حقيقية.",
  land_how_label: "كيف يعمل",
  land_how_title: "مصمَّم ليكون سهلاً بلا عناء",
  land_s1_t: "ثبّته بضغطة واحدة",
  land_s1_d: "أضف RoyalChat Nova إلى شاشتك الرئيسية — دون متجر تطبيقات ودون فوضى.",
  land_s2_t: "تحدّث بأناقة",
  land_s2_d: "محادثات غنية وفورية في واجهة أنيقة بالذهبي على الأسود.",
  land_s3_t: "كل شيء في مكان واحد",
  land_s3_d: "مكالمات ومجموعات ووسائط ومساعد ذكي — كل ذلك بين يديك بأناقة.",
  land_crafted: "مصمَّم لتجربة فاخرة",
  land_inside_label: "نظرة من الداخل",
  land_inside_title: "ملكي في التصميم، سهل في الاستخدام",
  land_mock_chats: "المحادثات",
  land_mock_convo: "محادثة",
  land_mock_ai: "المساعد الذكي",
  land_mock_talk_soon: "نتحدث قريباً 👑",
  land_mock_design: "فريق التصميم",
  land_mock_design_msg: "كوامي: تم الشحن ✅",
  land_mock_mother: "أمي",
  land_mock_mother_msg: "اتصل بي الليلة",
  land_mock_msg1: "هذا التطبيق فاخر جداً ✨",
  land_mock_msg2: "الأفضل فقط من أجلك 👑",
  land_mock_ai_desc: "اسأل أي شيء. لخّص المستندات. أملِ بصوتك — بمفاتيحك الخاصة.",
  land_install_title: "تثبيت RoyalChat Nova",
  land_install_sub: "احصل على التجربة الكاملة — أيقونة على الشاشة الرئيسية، وعمل دون اتصال، وإشعارات فورية.",
  land_install_now: "ثبّت الآن",
  land_installed: "مثبَّت بالفعل",
  land_iphone: "على iPhone (Safari 16.4+)",
  land_iphone_tap: "اضغط",
  land_iphone_add: "إضافة إلى الشاشة الرئيسية",
  land_native_apps: "التطبيقات الأصلية",
  land_download_on: "حمّله على",
  land_coming_soon: "قريباً",
  land_pillars_label: "تطبيق واحد · عالمان",
  land_p1_d: "محادثات فردية وجماعية سريعة، وألبومات وسائط، وملاحظات صوتية، ومكالمات صوت وفيديو فائقة الوضوح — مصمَّمة للعمل حتى على شبكة 4G ضعيفة.",
  land_p1_c1: "المجموعات",
  land_p1_c2: "المكالمات",
  land_p1_c3: "جاهز دون اتصال",
  land_p2_d: "انشر الصور، وأعجب، وعلّق، وشارك. أضف أصدقاء، وتابع أشخاصاً، وراسلهم في وارد اجتماعي منفصل عن محادثاتك.",
  land_p2_c1: "الأصدقاء",
  land_p2_c2: "متابعة",
  land_p2_c3: "الخلاصة",
  land_p3_d: "افتح متجراً، وأدرج سلعاً بالصور والسعر، وعزّز الإعلانات واستقبل رسائل المشترين — بِع عبر الإنترنت أو اعرض فقط.",
  land_p3_c1: "المتاجر",
  land_p3_c2: "قائمة الرغبات",
  land_p3_c3: "التقييمات",
  s_friend_added: "تمت إضافة الصديق",
  s_no_friends: "لا أصدقاء بعد — اكتشف أشخاصاً!",
  s_no_requests: "لا طلبات صداقة",
  s_no_people: "لم يُعثر على أشخاص",
  s_link_copied: "تم نسخ الرابط",
  s_check_post: "شاهد هذا المنشور",
  s_deleted: "تم الحذف",
  s_could_not_delete: "تعذّر الحذف",
  s_could_not_upload: "تعذّر رفع الصورة",
  s_posted: "تم النشر 🎉",
  s_could_not_post: "تعذّر النشر",
  s_public: "عام",
  s_could_not_upload_media: "تعذّر رفع الملف",
  s_document: "مستند",
  s_no_following_posts: "لا منشورات من أصدقائك أو ممن تتابعهم بعد.",
  s_reactions: "التفاعلات",
  s_replying_to: "الرد على",
  s_view_replies: "عرض {n} ردود",
  s_hide_replies: "إخفاء الردود",
  s_reshare: "إعادة المشاركة على صفحتي",
  s_reshared: "أعاد المشاركة",
  s_block_user: "حظر هذا المستخدم",
  s_reshared_toast: "أُعيدت المشاركة على صفحتك",
  s_user_blocked: "تم حظر المستخدم",
  s_reported: "تم الإبلاغ عن المنشور — شكراً",
  s_unfollowed: "تم إلغاء المتابعة",
  s_select: "تحديد",
  s_select_all: "تحديد الكل",
  s_message_selected: "رسالة ({n})",
  s_write_message: "اكتب رسالة…",
  s_broadcast_sent: "أُرسلت إلى {n} أشخاص",
  s_no_followers: "لا متابِعين بعد.",
  s_no_following: "لا تتابع أحداً بعد.",
  live_starting: "جارٍ بدء بثك…",
  live_connecting: "جارٍ الاتصال بالبث…",
  live_cam_fail: "الكاميرا/الميكروفون غير متاح",
  live_join_fail: "تعذّر الانضمام إلى البث",
  live_cam_switch_fail: "تعذّر تبديل الكاميرا",
  live_schedule_live: "جدولة بث",
  live_soon_toast: "سيبثّ قريباً",
  live_when_required: "اختر تاريخاً ووقتاً",
  live_cancel_sched_q: "إلغاء هذا البث المجدول؟",
  live_title_ph: "عمَّ يدور بثك؟",
  live_max_ph: "اتركه فارغاً لعدد غير محدود",
  live_replay_caption: "🔴 إعادة البث",
  live_replay_posted: "نُشرت الإعادة على خلاصتك",
  live_post_replay_q: "حفظ هذا البث كإعادة على خلاصتك؟",
  live_posting_replay: "جارٍ نشر الإعادة…",
  share_caption_ph: "قل شيئاً عن هذا…",
  share_to_timeline_ok: "تمت المشاركة على صفحتك",
  s_no_messages: "لا رسائل بعد",
  s_message_friend: "راسِل صديقاً من ملفه الشخصي",
  s_message_ph: "رسالة…",
  s_confirm_delete_social: "حذف كل بياناتك الاجتماعية (المنشورات، الأصدقاء، المتابعات، الرسائل)؟ لا يمكن التراجع.",
  s_social_deleted: "تم حذف البيانات الاجتماعية",
  s_requested: "تم الطلب",
  s_accept: "قبول",
  s_add_friend: "إضافة صديق",
  s_no_posts_yet: "لا منشورات بعد",
  s_delete_my_data: "حذف بياناتي الاجتماعية",
  s_delete_my_data_desc: "يزيل كل منشوراتك وتعليقاتك وأصدقائك ومتابعاتك ورسائلك الاجتماعية. يبقى حساب المحادثة.",
  m_no_items: "لا سلع بعد — افتح متجرك وأدرج شيئاً!",
  m_no_saved: "لا سلع محفوظة بعد — اضغط القلب على أي سلعة",
  m_link_copied: "تم نسخ الرابط",
  m_saved_wishlist: "حُفظت في قائمة الرغبات",
  m_removed: "أُزيلت",
  m_boosted: "معزَّزة",
  m_no_buyer_msgs: "لا رسائل مشترٍ/بائع بعد",
  m_message_seller_from: "راسِل بائعاً من أي سلعة",
  m_message_seller_ph: "راسِل البائع…",
  m_add_title: "أضف عنواناً",
  m_updated: "تم التحديث",
  m_listed: "تم الإدراج",
  m_could_not_save: "تعذّر الحفظ",
  m_upload_failed: "فشل الرفع",
  m_select: "اختر…",
  m_photos_left: "صور متبقية",
  m_photos_full: "تم بلوغ الحد الأقصى 5 صور",
  m_ph_title: "مثل سلة يدوية الصنع",
  m_ph_category: "المنزل",
  m_ph_location: "كيغالي",
  m_loading: "جارٍ التحميل…",
  m_saved_toast: "تم الحفظ",
  m_pick_star: "اختر تقييماً بالنجوم",
  m_thanks_review: "شكراً على تقييمك!",
  m_contact_price: "تواصل لمعرفة السعر",
  m_ratings_reviews: "التقييمات والمراجعات",
  m_rate_shop: "قيّم هذا المتجر",
  m_write_review: "اكتب مراجعة (اختياري)",
  m_submit_review: "إرسال المراجعة",
  m_you_rated: "لقد قيّمت هذا المتجر",
  m_no_reviews: "لا مراجعات بعد.",
  m_name_shop: "سمِّ متجرك",
  m_shop_saved: "تم حفظ المتجر",
  m_confirm_delete_shop: "حذف متجرك وكل سلعه؟ لا يمكن التراجع.",
  m_shop_deleted: "تم حذف المتجر",
  m_moved_archive: "نُقل إلى الأرشيف",
  m_reposted: "أُعيد النشر لمدة 30 يوماً",
  m_confirm_remove_item: "إزالة هذه السلعة نهائياً من قاعدة البيانات؟",
  m_promoted: "تمت الترقية إلى خلاصتك الاجتماعية! 🎉",
  m_could_not_promote: "تعذّرت الترقية",
  m_could_not_boost: "تعذّر بدء التعزيز",
  m_plan_updated: "تم تحديث الخطة",
  m_could_not_checkout: "تعذّر بدء الدفع",
  m_open_shop: "افتح متجرك",
  m_what_sell: "ماذا تبيع؟",
  m_shop_location: "الموقع (مثل كيغالي)",
  m_subscribe_to_sell: "اشترك في خطة بيع أدناه للبيع عبر الإنترنت",
  m_just_display: "عرض فقط",
  m_sell_online_locked: "البيع عبر الإنترنت 🔒",
  m_sell_online: "البيع عبر الإنترنت",
  m_plan_lets_sell: "خطتك تتيح لك البيع عبر الإنترنت.",
  m_selling_requires: "يتطلب البيع خطة مدفوعة (انظر الخطط أدناه). العرض مجاني.",
  m_selling_online: "البيع عبر الإنترنت",
  m_display_only: "عرض فقط",
  m_starter: "مبتدئ",
  m_pick_category_shop: "اختر فئة لمتجرك",
  m_add_location_shop: "أضف موقع متجرك",
  m_shop_ready: "متجرك جاهز بنسبة {n}%",
  m_banner_hint: "البانر — 1200×400 بكسل هو الأفضل",
  m_avatar_hint: "الشعار — مربّع، 400×400 بكسل يبدو أفضل",
  m_currency: "العملة",
  m_shop_location_short: "الموقع",
  m_see_plans: "عرض الخطط",
  m_plans_save_first: "احفظ متجرك أولاً، ثم اشترك في خطة بيع.",
  m_almost_there: "أوشكت — أضف فقط: {fields}",
  m_golive_desc: "بُثّ مباشرةً لمشتريك — قادم قريباً",
  m_report_chat: "إبلاغ المشرف",
  m_report_desc: "أبلِغ فريق RoyalChat Nova عن محادثتك مع {name}. سيراجعونها.",
  m_report_reason_ph: "ما الخطأ؟ (اختياري) — مثل طلب الدفع خارج التطبيق",
  m_report_submit: "إبلاغ المشرف",
  m_report_sent: "تم الإبلاغ للمشرف — شكراً",
  m_reason_offapp: "طلب الدفع خارج التطبيق",
  m_reason_fake: "سلعة مزيفة / احتيال",
  m_reason_noshow: "لم يحضر / لم يسلّم",
  m_reason_harassment: "تحرش/مضايقة",
  m_reason_other: "شيء آخر",
  m_text_seller: "راسِل البائع",
  m_sales: "المبيعات",
  m_no_sales: "لا مبيعات بعد",
  m_paid: "مدفوع",
  m_refunded: "مُسترد",
  m_sale_total: "إجمالي البيع",
  m_commission: "العمولة",
  m_you_receive: "تحصل على",
  m_refund_buyer: "استرداد للمشتري",
  m_confirm_refund: "استرداد المبلغ لهذا المشتري؟ لا يمكن التراجع.",
  m_refund_issued: "تم الاسترداد",
  m_payout_saved: "تم حفظ بيانات الاستلام — يمكنك البيع الآن",
  m_payout_ready: "يذهب المال إلى {method}",
  m_payout_needed: "أضف مكان استلامك للمال لبدء البيع",
  m_sell_pending: "البيع معلّق — أكمل إعداد الاستلام",
  m_payout_active: "المدفوعات مفعّلة",
  m_payout_receive_at: "تستلم المال في",
  m_payout_incomplete: "إعداد الاستلام غير مكتمل",
  m_selling_pending_short: "البيع (استلام معلّق)",
  m_payout_title: "بيانات الاستلام",
  m_payout_receive_note: "هنا حيث ستستلم أموال مبيعاتك — لا يتم خصم أي مبلغ منك.",
  m_payout_card: "بطاقة",
  m_payout_bank: "بنك",
  m_payout_card_name: "اسم حامل البطاقة",
  m_payout_card_number: "رقم البطاقة",
  m_payout_exp: "تاريخ الانتهاء",
  m_payout_cvv: "CVV",
  m_payout_acct_name: "اسم صاحب الحساب",
  m_payout_bank_name: "اسم البنك",
  m_payout_acct_number: "رقم الحساب",
  m_payout_routing: "رمز التوجيه / الفرع",
  m_payout_save: "احفظ وابدأ البيع",
  m_payout_secure_note: "نخزّن فقط مرجعاً مقنّعاً (مثل •••• 4242). تُفعّل المدفوعات الفعلية عند ربط مزوّد خدمة.",
  m_payout_fill: "يرجى إكمال جميع الحقول",
  m_payout_fail: "تعذّر حفظ بيانات الاستلام",
  m_payout_after_save: "احفظ متجرك ثم أضف بيانات الاستلام لبدء البيع.",
  m_lifetime_net: "إجمالي الأرباح",
  m_this_month: "هذا الشهر",
  m_mark_shipped: "وضع علامة: مشحون",
  m_mark_delivered: "وضع علامة: تم التسليم",
  m_marked_shipped: "تم وضع علامة مشحون — أُبلغ المشتري",
  m_marked_delivered: "تم وضع علامة تم التسليم — أُبلغ المشتري",
  m_fs_processing: "قيد التجهيز",
  m_fs_shipped: "مشحون",
  m_fs_delivered: "تم التسليم",
  m_orders: "الطلبات",
  m_no_orders: "لا طلبات بعد",
  m_track_processing: "قيد التجهيز",
  m_track_shipped: "مشحون",
  m_track_delivered: "تم التسليم",
  m_track_refunded: "مُسترد",
  m_sell_coming_soon: "البيع عبر الإنترنت قادم قريباً — ترقّبوا!",
  m_delete: "حذف",
  m_plans_title: "الخطط (حسب حجم المتجر)",
  m_up_to: "حتى",
  m_items_suffix: "سلع",
  m_can_sell: "يمكنه البيع عبر الإنترنت",
  m_display_only_low: "عرض فقط",
  m_per_mo: "/شهرياً",
  m_free: "مجاني",
  m_current: "الحالية",
  m_subscribe: "اشترك",
  m_choose: "اختر",
  m_my_items: "سلعي",
  m_dashboard: "لوحة التحكم",
  m_active_items: "السلع النشطة",
  m_archived: "المؤرشفة",
  m_total_views: "إجمالي المشاهدات",
  m_messages: "الرسائل",
  m_item_views_7d: "مشاهدات السلع (آخر 7 أيام)",
  m_buyer_msgs_7d: "رسائل المشترين (آخر 7 أيام)",
  m_boost: "تعزيز",
  m_promote: "ترويج",
  m_edit: "تعديل",
  m_repost: "إعادة نشر",
  m_no_items_yet: "لا سلع بعد",
  m_boost_item: "عزّز هذه السلعة",
  m_boost_desc_1: "ثبّت",
  m_boost_desc_2: "أعلى صفحة التصفّح. اختر مدة:",
  m_days: "أيام",
  m_no_boost_opts: "لا خيارات تعزيز مُعدّة بعد.",
  m_cancel: "إلغاء",
  a_messages: "الرسائل",
  a_online: "متصل",
  a_open_feedback: "الملاحظات المفتوحة",
  a_msgs_day: "الرسائل / يوم (14 يوم)",
  a_newusers_day: "مستخدمون جدد / يوم (14 يوم)",
  a_storage: "التخزين",
  a_database: "قاعدة البيانات",
  a_media_files: "ملفات الوسائط",
  a_set_new_pw: "تعيين كلمة مرور جديدة",
  a_new_pw_ph: "كلمة مرور جديدة (6 أحرف على الأقل)",
  a_save: "حفظ",
  a_broadcast_desc_1: "يُرسل من",
  a_broadcast_desc_2: "إلى كل مستخدم. لا يمكن للمستلمين الرد.",
  a_announcement_ph: "إعلانك…",
  a_remove: "إزالة",
  a_image: "صورة",
  a_file: "ملف",
  a_no_feedback: "لا ملاحظات بعد",
  a_answered: "تمت الإجابة",
  a_reply_ph: "ردك (من RoyalChat Nova)…",
  a_send: "إرسال",
  a_respond: "رد",
  a_delete: "حذف",
  a_deleted: "تم الحذف",
  a_media_desc: "تخزين الوسائط مقسّم حسب المجال. احذف مجالاً كاملاً لتحرير مساحة.",
  a_loading: "جارٍ التحميل…",
  a_chat_media: "وسائط المحادثات",
  a_social_media: "الوسائط الاجتماعية",
  a_market_media: "وسائط المتجر",
  a_files: "ملفات",
  a_currency: "العملة",
  a_currency_note: "يختار البائعون الآن عملة متجرهم. تُحتسب الرسوم والضرائب وأسعار الخطط بالدولار الأمريكي.",
  a_platform_fee: "رسوم المنصة (%)",
  a_reports: "البلاغات",
  a_no_reports: "لا بلاغات في المتجر 🎉",
  a_report: "بلاغ",
  a_warned: "تم التحذير",
  a_seller_suspended: "بائع موقوف",
  a_dismissed: "مرفوض",
  a_seller: "البائع",
  a_user_gone: "حساب محذوف",
  a_item: "السلعة",
  a_reason: "السبب",
  a_no_reason: "لم يُذكر سبب",
  a_reported_by: "أبلغ عنه",
  a_warn: "تحذير",
  a_unsuspend: "إلغاء الإيقاف",
  a_suspend: "إيقاف",
  a_dismiss: "رفض",
  a_confirm_suspend: "إيقاف هذا البائع؟ سيُخفى متجره وسلعه وسيُمنع من الدخول حتى إلغاء الإيقاف.",
  a_warn_sent: "أُرسل تحذير إلى البائع",
  a_suspended_ok: "تم إيقاف البائع",
  a_unsuspended_ok: "أُعيد تفعيل البائع",
  a_dismissed_ok: "تم رفض البلاغ",
  a_commission: "عمولة المنصة (%)",
  a_commission_note: "تُؤخذ العمولة من كل عملية بيع من جانب البائع — يدفع المشترون دائماً السعر المعروض.",
  a_payout_setup: "إعداد استلام أموال البائع",
  a_sell_shops: "متاجر البيع",
  a_payout_done: "الاستلام جاهز",
  a_payout_pending: "قيد الانتظار",
  a_welcome_title: "رسالة الترحيب",
  a_welcome_desc: "تُرسل تلقائياً من RoyalChat Nova إلى كل مستخدم لحظة تسجيله.",
  a_welcome_from: "تُرسل باسم",
  a_welcome_lang_hint: "اختر لغة، ثم عدّل الرسالة التي تظهر للمستخدمين الذين سجّلوا بتلك اللغة. اللغات التي تتركها فارغة ستعود إلى الإنجليزية.",
  a_welcome_saved: "تم حفظ رسالة الترحيب",
  a_on: "مفعّل",
  a_off: "متوقف",
  a_tax_percent: "ضريبة المبيعات (%)",
  a_sub_tiers: "مستويات الاشتراك (حسب حجم المتجر)",
  a_max_items: "الحد الأقصى للسلع",
  a_price_mo: "السعر /شهرياً",
  a_can_sell_paid: "يمكنه البيع عبر الإنترنت (ميزة مدفوعة)",
  a_listings_boost: "الإعلانات والتعزيز",
  a_listing_duration: "مدة الإعلان (أيام قبل انتهاء السلعة)",
  a_boost_opts: "خيارات التعزيز (تثبيت سلعة أعلى صفحة التصفّح)",
  a_days: "أيام",
  a_price: "السعر",
  a_categories: "الفئات",
  a_cat_desc: "قائمة مفصولة بفواصل يمكن للمشترين التصفية بها",
  a_save_market: "حفظ إعدادات المتجر",
  a_sellers_shops: "البائعون / المتاجر",
  a_items: "سلع",
  a_subscribed: "مشترك",
  a_unverify: "إلغاء التوثيق",
  a_verify: "توثيق",
  a_no_shops: "لا متاجر بعد",
  a_terms_desc: "عدّل الشروط والأحكام المعروضة للمستخدمين (تشمل المحادثات والاجتماعي والمتجر). بنمط Markdown: استخدم # و## للعناوين.",
  a_save_terms: "حفظ الشروط",
  a_free_space: "حرّر مساحة الآن",
  a_what_delete: "ما الذي تريد حذفه",
  a_select_all: "تحديد الكل",
  a_clear: "مسح",
  a_images: "صور",
  a_videos: "فيديوهات",
  a_audio: "صوت",
  a_documents: "مستندات",
  a_scope: "النطاق",
  a_older_than: "أقدم من…",
  a_delete_all: "حذف الكل",
  a_delete_older_days: "حذف العناصر الأقدم من (أيام)",
  a_delete_all_warn: "⚠️ يحذف هذا نهائياً كل عنصر محدد بغضّ النظر عن عمره. لا يمكن التراجع.",
  a_also_delete_files: "حذف الملفات المخزَّنة أيضاً (يحرّر أكبر مساحة)",
  a_running: "جارٍ التنفيذ…",
  a_delete_all_now: "حذف كل المحدد الآن",
  a_run_cleanup: "تشغيل التنظيف الآن",
  a_sched_cleanup: "تنظيف مجدول (يومي)",
  a_autodelete_days: "حذف تلقائي للأقدم من (أيام)",
  a_save_schedule: "حفظ الجدولة",
  a_custom_invite: "رسالة دعوة مخصَّصة",
  a_save_message: "حفظ الرسالة",
  a_load_failed: "فشل تحميل لوحة المشرف",
  a_failed: "فشل",
  a_market_saved: "تم حفظ إعدادات المتجر",
  a_terms_saved: "تم حفظ الشروط",
  a_verified: "موثّق",
  a_unverified: "غير موثّق",
  a_updated: "تم التحديث",
  a_delete_user_q: "حذف المستخدم؟",
  a_pw_min: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
  a_pw_updated: "تم تحديث كلمة المرور",
  a_pw_fail: "تعذّر تحديث كلمة المرور",
  a_upload_failed: "فشل الرفع",
  a_reply_sent: "تم إرسال الرد",
  a_pick_category: "اختر فئة واحدة على الأقل للحذف",
  a_schedule_saved: "تم حفظ الجدولة",
  a_invite_saved: "تم حفظ رسالة الدعوة",
  a_confirm_del_media: "حذف كل ملفات الوسائط في هذا المجال؟ لا يمكن التراجع.",
  a_files_deleted: "ملفات محذوفة",
  a_confirm_cleanup: "حذف الوسائط المحددة؟ لا يمكن التراجع.",
  a_removed: "أُزيلت",
  a_sent_broadcast: "تم إرسال البث",
  ss_title: "إعدادات التواصل",
  ss_desc: "حذف منشوراتي تلقائياً بعد فترة. يبقي خلاصتك مرتبة — يؤثر فقط على منشوراتك.",
  ss_saved: "تم الحفظ",
  ss_never: "أبداً (احتفظ للأبد)",
  ss_1m: "بعد شهر",
  ss_3m: "بعد 3 أشهر",
  ss_6m: "بعد 6 أشهر",
  ss_12m: "بعد 12 شهراً",
  set_available: "متاح على RoyalChat Nova",
  set_invite_title: "دعوة الأصدقاء",
  set_invite_desc: "شارك RoyalChat Nova مع جهات اتصالك",
  set_suggest_title: "أرسل اقتراحاً",
  set_suggest_desc: "ساعدنا على التحسّن — أرفق لقطة شاشة",
  set_away_title: "تنبيهات البريد أثناء الغياب",
  set_social_market: "الاجتماعي والمتجر",
  set_social_desc: "حذف تلقائي للمنشورات القديمة والمزيد",
  set_market_desc: "أدِر متجرك وسلعك ولوحة التحكم",
  set_terms_desc: "المحادثات والاجتماعي والمتجر",
  set_installed: "تم تثبيت التطبيق",
  set_installed_toast: "تم التثبيت ✓",
  set_ios_install: "Safari: مشاركة ← إضافة إلى الشاشة الرئيسية",
  set_browser_install: "قائمة المتصفح ← تثبيت التطبيق",
  set_not_supported: "غير مدعوم على هذا الجهاز",
  set_notif_fail: "تعذّر تفعيل الإشعارات",
  m_photos_max: "صور (حتى 5)",
  m_add_video: "إضافة فيديو",
  m_video: "فيديو عرض",
  m_remove_video: "إزالة الفيديو",
  m_stock_label: "كمية المخزون",
  m_stock_ph: "اتركه فارغاً لغير محدود",
  m_variants: "الخيارات (اللون، المقاس…)",
  m_add_option: "إضافة خيار",
  m_option_name_ph: "اسم الخيار (مثل اللون)",
  m_option_values_ph: "القيم مفصولة بفواصل (مثل أحمر، أزرق)",
  m_variant_stock: "المخزون لكل خيار",
  m_promo: "عرض ترويجي",
  m_promo_price: "سعر العرض",
  m_promo_days: "مدة العرض (أيام)",
  m_off: "خصم",
  m_ends_in: "ينتهي خلال",
  m_day_short: "ي",
  m_only_left: "بقي {n} فقط",
  m_more_from_shop: "المزيد من هذا المتجر",
  m_select_options: "اختر الخيارات",
  m_shop_avatar: "شعار المتجر (صغير)",
  m_shop_banner: "بانر المتجر (كبير)",
  m_upload_photo: "رفع",
  m_change_photo: "تغيير",
  m_featured_shops: "متاجر مميزة",
  m_recently_viewed: "شوهدت مؤخراً",
  m_shop_items: "السلع",
  m_shop_no_items: "لا سلع في هذا المتجر بعد",
  m_cart_empty: "سلتك فارغة",
  m_cart_empty_hint: "تصفّح السلع وأضفها هنا",
  m_choose_options_first: "اختر الخيارات أولاً",
  m_processing: "جارٍ المعالجة…",
};

export const hi = {
  safe_trade_title: "सुरक्षित लेन-देन करें", safe_trade_dismiss: "समझ गया",
  safe_tip_1: "स्थानीय सौदों के लिए किसी भीड़भाड़ वाली सार्वजनिक जगह पर मिलें।",
  safe_tip_2: "भुगतान से पहले वस्तु को खुद देखें-परखें।",
  safe_tip_3: "कभी भी अग्रिम भुगतान न करें और OTP / कार्ड / PIN कोड साझा न करें।",
  safe_tip_4: "अगर कीमत बहुत अच्छी लगे तो सतर्क रहें।",
  scam_warning: "जोखिम भरी भुगतान शर्तें। कभी अग्रिम भुगतान न करें और कोड साझा न करें।",
  scam_compose_warning: "यह जोखिम भरा लगता है। सुरक्षित रहें — अग्रिम भुगतान और कोड साझा करने से बचें।",
  photo_tips: "फ़ोटो सुझाव", photo_tips_title: "अच्छी फ़ोटो तेज़ी से बिकती हैं",
  photo_tip_1: "तेज़ प्राकृतिक रोशनी में फ़ोटो लें।",
  photo_tip_2: "वस्तु के कई कोण दिखाएं।",
  photo_tip_3: "साफ़, बिना बिखराव वाली पृष्ठभूमि का उपयोग करें।",
  photo_tip_4: "भरोसा बनाने के लिए किसी भी कमी को ईमानदारी से दिखाएं।",
  photo_tip_5: "फ़्रेम भरें — वस्तु के पास जाएं।",
  help_guide: "गाइड", guide_got_it: "समझ गया", coming_soon: "जल्द आ रहा है",
  guide_social_title: "सोशल में नेविगेट करें",
  guide_social_1: "फ़ीड — दोस्तों और फ़ॉलो किए लोगों की पोस्ट। खोजें पर स्विच करें।",
  guide_social_2: "मित्र — लोगों को खोजें, अनुरोध स्वीकारें और नए उपयोगकर्ता खोजें।",
  guide_social_3: "इनबॉक्स — निजी संदेश, अब फ़ोटो, वीडियो और वॉइस नोट्स के साथ।",
  guide_social_4: "मैं — आपकी प्रोफ़ाइल, पोस्ट और आँकड़े। पोस्ट के ⋯ मेनू से फ़ॉलो, शेयर या रिपोर्ट करें।",
  guide_market_title: "मार्केट में नेविगेट करें",
  guide_market_1: "ब्राउज़ करें — आइटम खोजें और विवरण देखने के लिए कार्ड पर टैप करें।",
  guide_market_2: "सहेजे गए — बाद के लिए पसंद किए आइटम।",
  guide_market_3: "मेरी दुकान — आइटम सूचीबद्ध करें, प्रोमो चलाएं और दुकान प्रबंधित करें।",
  guide_market_4: "इनबॉक्स — खरीदारों या विक्रेताओं से बात करें। सुनहरे ✔ सत्यापित-विक्रेता बैज को देखें।",
  open_app: "ऐप खोलें", get_started: "शुरू करें", install: "RoyalChat Nova इंस्टॉल करें", download_royalchat: "RoyalChat Nova डाउनलोड करें",
  login: "लॉग इन", register: "खाता बनाएं", email: "ईमेल", password: "पासवर्ड",
  name: "पूरा नाम", chats: "संदेश", search: "चैट खोजें…", new_chat: "नई चैट",
  settings: "सेटिंग्स", logout: "लॉग आउट", type_message: "संदेश लिखें…",
  pinned: "पिन किए गए", all_chats: "सभी चैट", online: "ऑनलाइन", typing: "लिख रहे हैं…",
  pin: "पिन करें", schedule: "शेड्यूल",
  no_chats: "अभी कोई बातचीत नहीं", start_conversation: "बातचीत शुरू करें",
  profile: "प्रोफ़ाइल", theme: "थीम", language: "भाषा", dark: "डार्क", light: "लाइट",
  ai_assistant: "AI सहायक", admin: "एडमिन", read_aloud: "ज़ोर से पढ़ें",
  admin_panel_desc: "उपयोगकर्ता, मीडिया और प्रसारण प्रबंधित करें",
  tab_chats: "चैट", tab_calls: "कॉल", tab_settings: "सेटिंग्स", tab_social: "सोशल", tab_market: "मार्केट",
  appearance: "रूप", preferences: "प्राथमिकताएँ", network: "नेटवर्क", connected: "कनेक्टेड",
  notifications: "सूचनाएँ", edit_profile: "प्रोफ़ाइल संपादित करें", phone: "फ़ोन नंबर",
  data_usage: "डेटा उपयोग", used_today: "आज उपयोग",
  country: "देश", about: "परिचय", change_password: "पासवर्ड बदलें", save: "सहेजें", cancel: "रद्द करें",
  pw_current: "मौजूदा पासवर्ड", pw_new: "नया पासवर्ड", pw_update: "अपडेट करें", pw_updated: "पासवर्ड अपडेट हुआ ✓", pw_fill_both: "मौजूदा और नया पासवर्ड डालें", pw_too_short: "नया पासवर्ड कम से कम 6 अक्षरों का होना चाहिए", pw_change_failed: "पासवर्ड नहीं बदल सका",
  auto_download: "मीडिया अपने-आप डाउनलोड", auto_download_desc: "चुनें कि कौन-सा मीडिया अपने-आप डाउनलोड हो", mt_images: "इमेज", mt_audio: "ऑडियो", mt_video: "वीडियो", mt_documents: "दस्तावेज़",
  clear_media_title: "सहेजा गया मीडिया मिटाएं?", clear_media_warn: "यह इस डिवाइस से डाउनलोड की गई सभी फ़ोटो, वीडियो, ऑडियो और दस्तावेज़ स्थायी रूप से हटा देगा। दोबारा खोलने पर वे फिर डाउनलोड होंगे।", clear_media_confirm: "मिटाएं",
  welcome_back: "वापसी पर स्वागत है", signin_continue: "अपनी बातचीत जारी रखने के लिए लॉग इन करें।",
  join_royalchat: "RoyalChat Nova से जुड़ें", create_seconds: "कुछ ही सेकंड में खाता बनाएं।",
  forgot_password: "पासवर्ड भूल गए?", new_here: "RoyalChat Nova पर नए हैं?", already_account: "पहले से खाता है?",
  email_or_phone: "ईमेल या फ़ोन नंबर", continue_google: "Google से जारी रखें", or_divider: "या",
  search_country: "देश खोजें…", no_results: "कोई परिणाम नहीं", today: "आज", yesterday: "कल",
  create_account_cta: "खाता बनाएं", login_tagline: "जहाँ बातचीत शाही बन जाती है",
  reply: "उत्तर", you: "आप", copy: "कॉपी", delete: "हटाएं", open: "खोलें", download: "डाउनलोड", copied: "कॉपी किया गया",
  forward: "आगे भेजें", forward_to: "यहाँ भेजें", forwarded: "अग्रेषित", this_chat: "यह चैट",
  block: "ब्लॉक", unblock: "अनब्लॉक",
  land_badge: "प्रीमियम मैसेजिंग अनुभव", land_hero_1: "जहाँ हर बातचीत लगे", land_hero_accent: "फर्स्ट क्लास",
  land_nav_features: "विशेषताएँ", land_nav_install: "इंस्टॉल", land_terms: "नियम और शर्तें",
  land_pillars_title: "चैट करें और जुड़ें — सब एक जगह",
  land_p1_t: "मैसेजिंग और कॉल", land_p2_t: "सोशल फ़ीड", land_p3_t: "मार्केटप्लेस",
  s_social: "सोशल", s_feed: "फ़ीड", s_friends: "दोस्त", s_inbox: "इनबॉक्स", s_me: "मैं",
  s_loading: "लोड हो रहा है…", s_no_posts: "अभी कोई पोस्ट नहीं। पहले साझा करें! 👑",
  s_failed: "विफल", s_request_sent: "अनुरोध भेजा गया", s_requests: "अनुरोध", s_discover: "खोजें", s_now: "अभी",
  s_search_people: "लोगों को खोजें…", s_add: "जोड़ें", s_sent: "भेजा गया",
  s_like: "पसंद", s_reply: "उत्तर", s_write_comment: "टिप्पणी लिखें…", s_write_reply: "उत्तर लिखें…",
  s_read_more: "और पढ़ें", s_read_less: "कम दिखाएं", s_views: "बार देखा", s_post: "पोस्ट", s_whats_mind: "आप क्या सोच रहे हैं?",
  s_add_photo: "फ़ोटो", s_add_video: "वीडियो", s_add_audio: "ऑडियो", s_add_document: "दस्तावेज़", s_take_photo: "कैमरा",
  s_following: "फ़ॉलोइंग", s_follow: "फ़ॉलो", s_unfollow: "अनफ़ॉलो", s_now_following: "अब फ़ॉलो कर रहे हैं", s_message: "संदेश", s_send: "भेजें",
  s_followers: "फ़ॉलोअर्स", s_posts: "पोस्ट", s_following_label: "फ़ॉलोइंग", s_back: "वापस", s_cancel: "रद्द करें",
  s_share_post: "पोस्ट साझा करें…", s_copy_link: "लिंक कॉपी करें", s_delete_post: "पोस्ट हटाएं", s_report_post: "पोस्ट रिपोर्ट करें",
  go_live: "लाइव जाएं", your_story: "आपकी स्टोरी", live_badge: "लाइव", live_now: "अभी लाइव है", s_watch: "देखें", live_ended: "लाइव समाप्त",
  live_say_something: "कुछ कहें…", live_now_strip: "अभी लाइव", live_full: "यह लाइव भरा है", live_buy: "खरीदें", s_close: "बंद करें",
  live_schedule_for_later: "बाद के लिए शेड्यूल करें", live_when_label: "तारीख और समय", live_upcoming: "आगामी लाइव",
  live_notify_me: "मुझे सूचित करें", live_notifying: "सूचित किया जाएगा", live_scheduled_ok: "लाइव शेड्यूल हुआ", live_go_now: "अभी लाइव जाएं",
  live_starts_in: "शुरू होगा", live_starting_soon: "जल्द शुरू", live_title_label: "शीर्षक (वैकल्पिक)",
  live_max_label: "अधिकतम दर्शक (वैकल्पिक)", live_pin_product: "उत्पाद पिन करें", live_end_btn: "लाइव समाप्त करें",
  live_filter_none: "कोई नहीं", live_filter_soft: "सॉफ्ट", live_filter_warm: "वॉर्म", live_filter_cool: "कूल", live_filter_vivid: "विविड", live_filter_mono: "श्वेत-श्याम",
  share: "साझा करें", share_to_timeline: "मेरी टाइमलाइन पर साझा करें", share_in_chat: "चैट में भेजें", share_copy_link: "लिंक कॉपी करें",
  share_more: "और…", share_link_copied: "लिंक कॉपी हुआ", share_sent: "भेजा गया", share_join_btn: "RoyalChat Nova से जुड़ें",
  share_join_cta: "अधिक देखने और विक्रेता से संपर्क के लिए RoyalChat Nova से जुड़ें।", share_not_found: "यह सामग्री अब उपलब्ध नहीं है।", m_view_product: "उत्पाद देखें",
  m_market: "मार्केट", m_browse: "ब्राउज़", m_saved: "सहेजे गए", m_my_shop: "मेरी दुकान", m_inbox: "इनबॉक्स",
  m_search_items: "आइटम खोजें…", m_all: "सभी", m_message: "संदेश", m_add_to_cart: "कार्ट में डालें", m_added_to_cart: "कार्ट में जोड़ा",
  m_title: "शीर्षक", m_price: "कीमत", m_description: "विवरण", m_category: "श्रेणी", m_location: "स्थान",
  m_list_item: "आइटम सूचीबद्ध करें", m_edit_item: "आइटम संपादित करें", m_publish: "आइटम प्रकाशित करें", m_save_changes: "बदलाव सहेजें",
  m_add_photos: "फ़ोटो जोड़ें", m_take_photo: "कैमरा", m_seller: "विक्रेता", m_message_seller: "विक्रेता को संदेश",
  m_cart: "कार्ट", m_checkout: "चेकआउट", m_subtotal: "उप-योग", m_tax: "कर", m_total: "कुल", m_remove: "हटाएं",
  m_visit_shop: "दुकान देखें", m_in_stock: "स्टॉक में", m_out_of_stock: "स्टॉक ख़त्म", m_qty: "मात्रा", m_each: "प्रति",
  m_edit_shop: "दुकान संपादित करें", m_shop_name: "दुकान का नाम", m_save_shop: "दुकान सहेजें", m_add_item: "आइटम जोड़ें",
  a_dashboard: "एडमिन डैशबोर्ड", a_overview: "अवलोकन", a_users: "उपयोगकर्ता", a_broadcast: "प्रसारण", a_feedback: "प्रतिक्रिया",
  a_media: "मीडिया", a_market: "मार्केट", a_terms: "शर्तें", a_cleanup: "सफ़ाई", a_permissions: "सेक्शन अनुमतियाँ",
  set_social_title: "सोशल सेटिंग्स", set_market_title: "मार्केट सेटिंग्स", set_terms_title: "नियम और शर्तें",
  help_support: "सहायता और समर्थन", blocked_contacts: "ब्लॉक किए संपर्क", verify_email: "मेरा ईमेल सत्यापित करें",
  st_new_story: "नई स्टोरी", st_camera: "कैमरा", st_camera_sub: "फ़ोटो या वीडियो", st_gallery: "गैलरी", st_gallery_sub: "डिवाइस से अपलोड करें", st_text: "टेक्स्ट", st_text_sub: "बैकग्राउंड पर लिखें",
  st_type_something: "कुछ लिखें…", st_sticker: "स्टिकर", st_poll: "पोल", st_ask: "सवाल", st_link: "लिंक", st_draw: "ड्रॉ", st_music: "संगीत",
  st_undo: "पूर्ववत", st_clear: "मिटाएँ", st_done: "हो गया", st_add_caption: "कैप्शन जोड़ें…", st_public: "सार्वजनिक", st_friends: "मित्र", st_close_friends: "करीबी मित्र",
  st_also_share: "फ़ीड में भी शेयर करें", st_post_story: "स्टोरी पोस्ट करें", st_add_poll: "पोल जोड़ें", st_ask_question: "सवाल पूछें", st_add_link: "लिंक जोड़ें",
  st_question_opt: "सवाल (वैकल्पिक)", st_option1: "विकल्प 1", st_option2: "विकल्प 2", st_ask_me: "मुझसे कुछ भी पूछें", st_btn_label: "बटन लेबल (वैकल्पिक)",
  st_cancel: "रद्द करें", st_add: "जोड़ें", st_visit_link: "लिंक देखें", st_uploading: "अपलोड हो रहा है…", st_upload_own: "अपना अपलोड करें",
  st_your_story: "आपकी स्टोरी", st_views: "व्यू", st_view: "व्यू", st_reply_to: "जवाब दें", st_insights: "इनसाइट्स", st_story_insights: "स्टोरी इनसाइट्स",
  st_replies: "जवाब", st_reactions: "प्रतिक्रियाएँ", st_no_answers: "अभी कोई जवाब नहीं", st_viewers: "व्यूअर", st_no_viewers: "अभी कोई व्यू नहीं",
  st_replies_in_insights: "जवाब आपके इनसाइट्स में दिखते हैं", st_sent: "भेज दिया ✨", st_type_short: "लिखें…",
  st_new_highlight: "नया हाइलाइट", st_hl_name_ph: "नाम (जैसे यात्रा, परिवार)", st_hl_cover_hint: "कस्टम कवर चुनने के लिए वृत्त पर टैप करें (वैकल्पिक — वरना पहली स्टोरी उपयोग होगी)।",
  st_hl_choose: "शामिल करने के लिए स्टोरी चुनें", st_hl_selected: "चयनित", st_hl_none: "अभी आपकी कोई स्टोरी नहीं है। पहले स्टोरी पोस्ट करें, फिर यहाँ सेव करें।",
  st_save_highlight: "हाइलाइट सेव करें", st_new: "नया", st_edit: "संपादित करें",
  st_story_posted: "स्टोरी पोस्ट हुई ✨", st_post_failed: "स्टोरी पोस्ट नहीं हो सकी", st_music_added: "संगीत जोड़ा 🎵", st_upload_failed: "अपलोड विफल",
  st_two_options: "दो विकल्प जोड़ें", st_enter_url: "एक URL दर्ज करें", st_hl_saved: "हाइलाइट सेव हुआ ⭐", st_pick_story: "कम से कम एक स्टोरी चुनें",
  st_cover_failed: "कवर अपलोड विफल", st_hl_deleted: "हाइलाइट हटाया गया", st_cover_updated: "कवर अपडेट हुआ", st_order_saved: "क्रम सेव हुआ", st_failed: "विफल",
  st_reply_sent: "जवाब भेजा गया", st_story_deleted: "स्टोरी हटाई गई", st_empty_highlight: "यह हाइलाइट खाली है", st_delete_story_q: "यह स्टोरी हटाएँ?", st_delete_hl_q: "यह हाइलाइट हटाएँ?",
  call_voice: "वॉइस कॉल", call_video: "वीडियो कॉल", call_missed_voice: "छूटी वॉइस कॉल", call_missed_video: "छूटी वीडियो कॉल",
  call_failed: "कॉल विफल", call_no_answer: "कोई जवाब नहीं", call_try_again: "फिर से कोशिश करें", call_tap_back: "वापस कॉल करने के लिए टैप करें", call_min: "मिनट", call_sec: "सेकंड",
  call_lbl_mute: "म्यूट", call_lbl_unmute: "अनम्यूट", call_lbl_speaker: "स्पीकर", call_lbl_headset: "हेडसेट", call_lbl_camera: "कैमरा", call_lbl_flip: "फ्लिप", call_lbl_saver: "डेटा सेवर", call_lbl_end: "समाप्त", call_lbl_answer: "उत्तर दें", call_lbl_decline: "अस्वीकार", call_lbl_fullscreen: "फुल स्क्रीन", call_lbl_normal: "सामान्य",

  // --- Completed translations (auto-added) ---
  ultra_lite: "अल्ट्रा-लाइट मोड",
  ultra_lite_desc: "केवल टेक्स्ट: मीडिया टैप पर, लिंक प्रीव्यू बंद",
  auto_delete_media: "मीडिया अपने-आप हटाएं",
  auto_delete_desc: "जगह खाली करने के लिए इससे पुराना सहेजा मीडिया हटाएं",
  app_lock: "ऐप लॉक",
  app_lock_desc: "ऐप खोलने के लिए PIN अनिवार्य करें",
  app_lock_on: "चालू · खोलने के लिए PIN ज़रूरी",
  notifications_on: "सूचनाएँ चालू",
  notifications_blocked: "सूचनाएँ अवरुद्ध",
  ios_install_for_push: "iPhone पर: शेयर ← होम स्क्रीन में जोड़ें दबाएं, फिर सूचनाएँ चालू करने के लिए RoyalChat Nova को होम स्क्रीन से खोलें।",
  or_pick_avatar: "या एक अवतार चुनें",
  calls: "कॉल",
  all: "सभी",
  missed: "छूटी",
  no_calls: "अभी कोई कॉल नहीं",
  configure_ai: "AI कॉन्फ़िगर करें",
  get_free_key: "मुफ़्त की पाएं",
  how_get_key: "अपनी की कैसे पाएं (1 मिनट, बिना कार्ड)",
  reset_pw_title: "पासवर्ड रीसेट करें",
  reset_pw_desc: "रीसेट लिंक पाने के लिए अपना ईमेल दर्ज करें।",
  send_reset: "रीसेट लिंक भेजें",
  back_login: "लॉग इन पर वापस",
  back_home: "होम पर वापस",
  readonly_notice: "यह एक आधिकारिक RoyalChat Nova चैनल है — आप यहाँ उत्तर नहीं दे सकते।",
  channel_readonly_notice: "इस चैनल में केवल एडमिन पोस्ट कर सकते हैं।",
  create_account_title: "अपना\nखाता बनाएं",
  create_account_sub: "RoyalChat Nova से जुड़ें और चैट शुरू करें",
  complete_profile_prompt: "अपना देश और फ़ोन जोड़ें ताकि दोस्त आपको ढूँढ और कॉल कर सकें।",
  complete_profile_cta: "प्रोफ़ाइल पूरी करें",
  dismiss: "खारिज करें",
  remove_key: "की हटाएं",
  key_removed: "की हटाई गई",
  attach_photos: "फ़ोटो",
  attach_document: "दस्तावेज़",
  attach_sticker: "स्टिकर",
  attach_camera: "कैमरा",
  poll: "पोल",
  read_receipts: "रीड रसीदें",
  read_receipts_desc: "संदेश पढ़ने पर नीले निशान दिखाएं",
  sending_tap_cancel: "भेजा जा रहा है… रद्द करने के लिए टैप करें",
  recording: "रिकॉर्ड हो रहा है…",
  data_storage: "डेटा और स्टोरेज",
  data_saver: "डेटा सेवर",
  data_saver_desc: "फ़ोटो, ऑडियो और वीडियो को ज़ोर से संपीड़ित करें",
  autodl_off: "कभी नहीं",
  autodl_wifi: "केवल Wi-Fi",
  autodl_always: "हमेशा",
  undo_send_title: "भेजने से पहले पूर्ववत करें",
  undo_send_desc: "संदेशों में देरी करें ताकि आप रद्द कर सकें",
  storage_cleanup: "सहेजा गया मीडिया मिटाएं",
  storage_cleanup_desc: "इस डिवाइस पर सहेजे फ़ोटो, ऑडियो और दस्तावेज़ हटाएं",
  storage_cleared: "स्टोरेज साफ़ हुआ",
  help_support_desc: "सामान्य प्रश्न और मदद कैसे पाएं",
  privacy_help: "गोपनीयता और मदद",
  sounds_ringtones: "ध्वनियाँ और रिंगटोन",
  sound_effects: "ध्वनि प्रभाव",
  sound_effects_desc: "भेजे, प्राप्त और कॉल के लिए टोन बजाएं",
  tone_sent: "भेजा संदेश",
  tone_received: "प्राप्त संदेश",
  tone_call: "आती कॉल",
  verified: "सत्यापित",
  not_verified: "असत्यापित",
  verify_email_desc: "अपने खाते पर सत्यापित बैज पाएं",
  verify_intro: "यह पुष्टि करने के लिए कि यह वाकई आप हैं, हम आपके ईमेल पर 6-अंकों का कोड भेजेंगे।",
  verify_send_code: "कोड भेजें",
  verify_enter_code: "हमने आपके ईमेल पर जो 6-अंकों का कोड भेजा है वह दर्ज करें",
  verify_confirm: "ईमेल सत्यापित करें",
  verify_success: "ईमेल सत्यापित हुआ",
  verify_code_sent: "कोड आपके ईमेल पर भेजा गया",
  verify_invalid: "अमान्य या समाप्त कोड",
  verify_resend: "कोड फिर भेजें",
  already_verified: "आपका ईमेल सत्यापित है",
  blocked_contacts_desc: "आपने जिन्हें ब्लॉक किया उन्हें प्रबंधित करें",
  no_blocked: "आपने किसी को ब्लॉक नहीं किया",
  block_contact: "संपर्क ब्लॉक करें",
  blocked_toast: "संपर्क ब्लॉक हुआ",
  unblocked_toast: "संपर्क अनब्लॉक हुआ",
  tap_to_download: "डाउनलोड के लिए टैप करें",
  poor_connection_quality: "कमज़ोर कनेक्शन · गुणवत्ता कम",
  call_reconnecting: "फिर से कनेक्ट हो रहा है…",
  messages_label: "संदेश",
  one_message_label: "1 संदेश",
  forwarded_label: "अग्रेषित",
  load_older: "पुराने संदेश लोड करें",
  loading_older: "लोड हो रहा है…",
  jump_to_latest: "नवीनतम पर जाएं",
  land_hero_sub: "बेहद बारीकी से बनाया गया मैसेंजर — परिष्कृत कॉल, एक बुद्धिमान सहायक, और हर विवरण में स्वर्ण-स्तरीय अनुभव। सुरुचिपूर्ण, सहज और इंस्टॉल करने योग्य।",
  land_cap_label: "क्षमताएँ",
  land_cap_title: "जो चाहिए वह सब, जो धीमा करे कुछ नहीं",
  land_f1_t: "बेदाग परिष्कृत",
  land_f1_d: "बारीकी से बनाई गई इंटरफ़ेस जहाँ हर इंटरैक्शन एक दर्जा ऊपर लगता है।",
  land_f2_t: "क्रिस्टल-स्पष्ट कॉल",
  land_f2_d: "सुरुचिपूर्ण इन-कॉल कंट्रोल के साथ हाई-डेफ़िनिशन 1:1 और ग्रुप ऑडियो-वीडियो कॉल।",
  land_f3_t: "AI सहायक",
  land_f3_d: "अपनी Groq / Gemini / OpenRouter की लाएं। त्वरित प्रॉम्प्ट, वॉइस डिक्टेशन, दस्तावेज़ विश्लेषण।",
  land_f4_t: "स्टिकर और मीडिया",
  land_f4_d: "एनिमेटेड स्टिकर, इमेज-वीडियो एल्बम, ऑडियो नोट्स और दस्तावेज़ — खूबसूरती से प्रस्तुत।",
  land_f5_t: "ग्रुप और एडमिन",
  land_f5_d: "ग्रुप बनाएं, सदस्य और एडमिन प्रबंधित करें, आमंत्रक के नाम के साथ वैयक्तिकृत आमंत्रण।",
  land_f6_t: "इंस्टॉल करने योग्य PWA",
  land_f6_d: "Android और iOS पर सच्चे नेटिव-ऐप अनुभव के लिए RoyalChat Nova को अपनी होम स्क्रीन में जोड़ें।",
  land_how_label: "यह कैसे काम करता है",
  land_how_title: "सहज महसूस कराने के लिए बनाया गया",
  land_s1_t: "एक टैप में इंस्टॉल करें",
  land_s1_d: "RoyalChat Nova को अपनी होम स्क्रीन में जोड़ें — कोई ऐप स्टोर नहीं, कोई अव्यवस्था नहीं।",
  land_s2_t: "अंदाज़ से बात करें",
  land_s2_d: "परिष्कृत काले-पर-सुनहरे इंटरफ़ेस में समृद्ध, रीयल-टाइम बातचीत।",
  land_s3_t: "सब कुछ एक जगह",
  land_s3_d: "कॉल, ग्रुप, मीडिया और एक AI सहायक — सब कुछ सुरुचिपूर्ण ढंग से आपकी उंगलियों पर।",
  land_crafted: "प्रीमियम अनुभव के लिए तैयार",
  land_inside_label: "एक झलक अंदर",
  land_inside_title: "डिज़ाइन में शाही, उपयोग में सहज",
  land_mock_chats: "चैट",
  land_mock_convo: "बातचीत",
  land_mock_ai: "AI सहायक",
  land_mock_talk_soon: "जल्द बात करते हैं 👑",
  land_mock_design: "डिज़ाइन टीम",
  land_mock_design_msg: "क्वामे: भेज दिया ✅",
  land_mock_mother: "माँ",
  land_mock_mother_msg: "आज रात मुझे कॉल करना",
  land_mock_msg1: "यह ऐप बहुत प्रीमियम लगता है ✨",
  land_mock_msg2: "आपके लिए सिर्फ़ सबसे बेहतरीन 👑",
  land_mock_ai_desc: "कुछ भी पूछें। दस्तावेज़ों का सारांश करें। बोलकर डिक्टेट करें — अपनी की के साथ।",
  land_install_title: "RoyalChat Nova इंस्टॉल करें",
  land_install_sub: "पूरा ऐप अनुभव पाएं — होम-स्क्रीन आइकन, ऑफ़लाइन शेल और पुश सूचनाएँ।",
  land_install_now: "अभी इंस्टॉल करें",
  land_installed: "पहले से इंस्टॉल",
  land_iphone: "iPhone पर (Safari 16.4+)",
  land_iphone_tap: "टैप करें",
  land_iphone_add: "होम स्क्रीन में जोड़ें",
  land_native_apps: "नेटिव ऐप्स",
  land_download_on: "यहाँ से डाउनलोड करें",
  land_coming_soon: "जल्द आ रहा है",
  land_pillars_label: "एक ऐप · दो दुनिया",
  land_p1_d: "तेज़ 1:1 और ग्रुप चैट, मीडिया एल्बम, वॉइस नोट्स और क्रिस्टल-स्पष्ट ऑडियो-वीडियो कॉल — कमज़ोर 4G पर भी चलने के लिए बनाए गए।",
  land_p1_c1: "ग्रुप",
  land_p1_c2: "कॉल",
  land_p1_c3: "ऑफ़लाइन-रेडी",
  land_p2_d: "फ़ोटो पोस्ट करें, पसंद करें, टिप्पणी और शेयर करें। दोस्त जोड़ें, लोगों को फ़ॉलो करें और उन्हें आपकी चैट से अलग सोशल इनबॉक्स में संदेश भेजें।",
  land_p2_c1: "दोस्त",
  land_p2_c2: "फ़ॉलो",
  land_p2_c3: "फ़ीड",
  land_p3_d: "एक दुकान खोलें, फ़ोटो और कीमत के साथ आइटम सूचीबद्ध करें, लिस्टिंग बूस्ट करें और खरीदारों के संदेश पाएं — ऑनलाइन बेचें या केवल प्रदर्शित करें।",
  land_p3_c1: "दुकानें",
  land_p3_c2: "विशलिस्ट",
  land_p3_c3: "समीक्षाएँ",
  s_friend_added: "दोस्त जोड़ा गया",
  s_no_friends: "अभी कोई दोस्त नहीं — लोगों को खोजें!",
  s_no_requests: "कोई मित्र अनुरोध नहीं",
  s_no_people: "कोई व्यक्ति नहीं मिला",
  s_link_copied: "लिंक कॉपी हुआ",
  s_check_post: "यह पोस्ट देखें",
  s_deleted: "हटाया गया",
  s_could_not_delete: "हटाया नहीं जा सका",
  s_could_not_upload: "इमेज अपलोड नहीं हो सकी",
  s_posted: "पोस्ट हुआ 🎉",
  s_could_not_post: "पोस्ट नहीं हो सका",
  s_public: "सार्वजनिक",
  s_could_not_upload_media: "फ़ाइल अपलोड नहीं हो सकी",
  s_document: "दस्तावेज़",
  s_no_following_posts: "आपके दोस्तों या आप जिन्हें फ़ॉलो करते हैं उनकी अभी कोई पोस्ट नहीं।",
  s_reactions: "प्रतिक्रियाएँ",
  s_replying_to: "जवाब दे रहे हैं",
  s_view_replies: "{n} जवाब देखें",
  s_hide_replies: "जवाब छिपाएं",
  s_reshare: "मेरी टाइमलाइन पर पुनः शेयर करें",
  s_reshared: "ने पुनः शेयर किया",
  s_block_user: "इस उपयोगकर्ता को ब्लॉक करें",
  s_reshared_toast: "आपकी टाइमलाइन पर पुनः शेयर हुआ",
  s_user_blocked: "उपयोगकर्ता ब्लॉक हुआ",
  s_reported: "पोस्ट रिपोर्ट हुई — धन्यवाद",
  s_unfollowed: "अनफ़ॉलो किया",
  s_select: "चुनें",
  s_select_all: "सभी चुनें",
  s_message_selected: "संदेश ({n})",
  s_write_message: "एक संदेश लिखें…",
  s_broadcast_sent: "{n} लोगों को भेजा गया",
  s_no_followers: "अभी कोई फ़ॉलोअर नहीं।",
  s_no_following: "आप अभी किसी को फ़ॉलो नहीं करते।",
  live_starting: "आपका लाइव शुरू हो रहा है…",
  live_connecting: "लाइव से कनेक्ट हो रहा है…",
  live_cam_fail: "कैमरा/माइक्रोफ़ोन उपलब्ध नहीं",
  live_join_fail: "लाइव में शामिल नहीं हो सके",
  live_cam_switch_fail: "कैमरा नहीं बदल सकते",
  live_schedule_live: "लाइव शेड्यूल करें",
  live_soon_toast: "जल्द लाइव जाएंगे",
  live_when_required: "तारीख और समय चुनें",
  live_cancel_sched_q: "यह शेड्यूल किया लाइव रद्द करें?",
  live_title_ph: "आपका लाइव किस बारे में है?",
  live_max_ph: "असीमित के लिए खाली छोड़ें",
  live_replay_caption: "🔴 लाइव रीप्ले",
  live_replay_posted: "रीप्ले आपकी फ़ीड पर पोस्ट हुई",
  live_post_replay_q: "इस लाइव को अपनी फ़ीड पर रीप्ले के रूप में सहेजें?",
  live_posting_replay: "रीप्ले पोस्ट हो रही है…",
  share_caption_ph: "इसके बारे में कुछ कहें…",
  share_to_timeline_ok: "आपकी टाइमलाइन पर शेयर हुआ",
  s_no_messages: "अभी कोई संदेश नहीं",
  s_message_friend: "किसी दोस्त को उसकी प्रोफ़ाइल से संदेश भेजें",
  s_message_ph: "संदेश…",
  s_confirm_delete_social: "अपना सारा सोशल डेटा (पोस्ट, दोस्त, फ़ॉलो, संदेश) हटाएं? इसे पूर्ववत नहीं किया जा सकता।",
  s_social_deleted: "सोशल डेटा हटाया गया",
  s_requested: "अनुरोधित",
  s_accept: "स्वीकारें",
  s_add_friend: "दोस्त जोड़ें",
  s_no_posts_yet: "अभी कोई पोस्ट नहीं",
  s_delete_my_data: "मेरा सोशल डेटा हटाएं",
  s_delete_my_data_desc: "आपकी सभी पोस्ट, टिप्पणियाँ, दोस्त, फ़ॉलो और सोशल संदेश हटा देता है। आपका चैट खाता बना रहता है।",
  m_no_items: "अभी कोई आइटम नहीं — अपनी दुकान खोलें और कुछ सूचीबद्ध करें!",
  m_no_saved: "अभी कोई सहेजा आइटम नहीं — किसी भी आइटम पर दिल टैप करें",
  m_link_copied: "लिंक कॉपी हुआ",
  m_saved_wishlist: "विशलिस्ट में सहेजा",
  m_removed: "हटाया गया",
  m_boosted: "बूस्ट किया",
  m_no_buyer_msgs: "अभी कोई खरीदार/विक्रेता संदेश नहीं",
  m_message_seller_from: "किसी भी आइटम से विक्रेता को संदेश भेजें",
  m_message_seller_ph: "विक्रेता को संदेश भेजें…",
  m_add_title: "एक शीर्षक जोड़ें",
  m_updated: "अपडेट हुआ",
  m_listed: "सूचीबद्ध",
  m_could_not_save: "सहेजा नहीं जा सका",
  m_upload_failed: "अपलोड विफल",
  m_select: "चुनें…",
  m_photos_left: "फ़ोटो शेष",
  m_photos_full: "अधिकतम 5 फ़ोटो तक पहुँच गए",
  m_ph_title: "जैसे हस्तनिर्मित टोकरी",
  m_ph_category: "घर",
  m_ph_location: "कीगाली",
  m_loading: "लोड हो रहा है…",
  m_saved_toast: "सहेजा गया",
  m_pick_star: "एक स्टार रेटिंग चुनें",
  m_thanks_review: "आपकी समीक्षा के लिए धन्यवाद!",
  m_contact_price: "कीमत के लिए संपर्क करें",
  m_ratings_reviews: "रेटिंग और समीक्षाएँ",
  m_rate_shop: "इस दुकान को रेट करें",
  m_write_review: "समीक्षा लिखें (वैकल्पिक)",
  m_submit_review: "समीक्षा सबमिट करें",
  m_you_rated: "आपने इस दुकान को रेट किया",
  m_no_reviews: "अभी कोई समीक्षा नहीं।",
  m_name_shop: "अपनी दुकान का नाम रखें",
  m_shop_saved: "दुकान सहेजी गई",
  m_confirm_delete_shop: "अपनी दुकान और उसके सभी आइटम हटाएं? इसे पूर्ववत नहीं किया जा सकता।",
  m_shop_deleted: "दुकान हटाई गई",
  m_moved_archive: "आर्काइव में ले जाया गया",
  m_reposted: "30 दिनों के लिए फिर पोस्ट किया",
  m_confirm_remove_item: "इस आइटम को डेटाबेस से स्थायी रूप से हटाएं?",
  m_promoted: "आपकी सोशल फ़ीड पर प्रचारित! 🎉",
  m_could_not_promote: "प्रचारित नहीं किया जा सका",
  m_could_not_boost: "बूस्ट शुरू नहीं हो सका",
  m_plan_updated: "प्लान अपडेट हुआ",
  m_could_not_checkout: "चेकआउट शुरू नहीं हो सका",
  m_open_shop: "अपनी दुकान खोलें",
  m_what_sell: "आप क्या बेचते हैं?",
  m_shop_location: "स्थान (जैसे कीगाली)",
  m_subscribe_to_sell: "ऑनलाइन बेचने के लिए नीचे किसी बिक्री प्लान की सदस्यता लें",
  m_just_display: "केवल प्रदर्शन",
  m_sell_online_locked: "ऑनलाइन बेचें 🔒",
  m_sell_online: "ऑनलाइन बेचें",
  m_plan_lets_sell: "आपका प्लान आपको ऑनलाइन बेचने देता है।",
  m_selling_requires: "बेचने के लिए एक सशुल्क प्लान चाहिए (नीचे प्लान देखें)। प्रदर्शन मुफ़्त है।",
  m_selling_online: "ऑनलाइन बेच रहे हैं",
  m_display_only: "केवल प्रदर्शन",
  m_starter: "स्टार्टर",
  m_pick_category_shop: "अपनी दुकान के लिए एक श्रेणी चुनें",
  m_add_location_shop: "अपनी दुकान का स्थान जोड़ें",
  m_shop_ready: "आपकी दुकान {n}% तैयार है",
  m_banner_hint: "बैनर — 1200×400px सबसे अच्छा चलता है",
  m_avatar_hint: "लोगो — वर्गाकार, 400×400px सबसे अच्छा दिखता है",
  m_currency: "मुद्रा",
  m_shop_location_short: "स्थान",
  m_see_plans: "प्लान देखें",
  m_plans_save_first: "पहले अपनी दुकान सहेजें, फिर किसी बिक्री प्लान की सदस्यता लें।",
  m_almost_there: "बस थोड़ा और — केवल जोड़ें: {fields}",
  m_golive_desc: "अपने खरीदारों के लिए लाइव प्रसारण करें — जल्द आ रहा है",
  m_report_chat: "एडमिन को रिपोर्ट करें",
  m_report_desc: "{name} के साथ अपनी चैट को RoyalChat Nova टीम को फ़्लैग करें। वे इसकी समीक्षा करेंगे।",
  m_report_reason_ph: "क्या गड़बड़ है? (वैकल्पिक) — जैसे ऐप के बाहर भुगतान माँगा",
  m_report_submit: "एडमिन को रिपोर्ट करें",
  m_report_sent: "एडमिन को रिपोर्ट किया — धन्यवाद",
  m_reason_offapp: "ऐप के बाहर भुगतान माँगा",
  m_reason_fake: "नकली / धोखाधड़ी वाला आइटम",
  m_reason_noshow: "नहीं आया / डिलीवर नहीं किया",
  m_reason_harassment: "उत्पीड़न",
  m_reason_other: "कुछ और",
  m_text_seller: "विक्रेता को संदेश करें",
  m_sales: "बिक्री",
  m_no_sales: "अभी कोई बिक्री नहीं",
  m_paid: "भुगतान किया",
  m_refunded: "वापस किया गया",
  m_sale_total: "बिक्री कुल",
  m_commission: "कमीशन",
  m_you_receive: "आपको मिलता है",
  m_refund_buyer: "खरीदार को रिफ़ंड",
  m_confirm_refund: "इस खरीदार को रिफ़ंड करें? इसे पूर्ववत नहीं किया जा सकता।",
  m_refund_issued: "रिफ़ंड जारी",
  m_payout_saved: "भुगतान विवरण सहेजा गया — अब आप बेच सकते हैं",
  m_payout_ready: "पैसा {method} पर जाता है",
  m_payout_needed: "बेचना शुरू करने के लिए जोड़ें कि आप पैसा कहाँ पाएंगे",
  m_sell_pending: "बिक्री लंबित — भुगतान सेटअप पूरा करें",
  m_payout_active: "भुगतान सक्रिय",
  m_payout_receive_at: "आप पैसा यहाँ पाते हैं",
  m_payout_incomplete: "भुगतान सेटअप अधूरा",
  m_selling_pending_short: "बेच रहे हैं (भुगतान लंबित)",
  m_payout_title: "भुगतान विवरण",
  m_payout_receive_note: "यहीं आप अपनी बिक्री का पैसा प्राप्त करेंगे — आपसे कोई शुल्क नहीं लिया जा रहा।",
  m_payout_card: "कार्ड",
  m_payout_bank: "बैंक",
  m_payout_card_name: "कार्डधारक का नाम",
  m_payout_card_number: "कार्ड नंबर",
  m_payout_exp: "समाप्ति",
  m_payout_cvv: "CVV",
  m_payout_acct_name: "खाताधारक का नाम",
  m_payout_bank_name: "बैंक का नाम",
  m_payout_acct_number: "खाता संख्या",
  m_payout_routing: "रूटिंग / सॉर्ट कोड",
  m_payout_save: "सहेजें और बेचना शुरू करें",
  m_payout_secure_note: "हम केवल एक मास्क किया संदर्भ सहेजते हैं (जैसे •••• 4242)। वास्तविक भुगतान किसी प्रदाता के जुड़ते ही सक्रिय होते हैं।",
  m_payout_fill: "कृपया सभी फ़ील्ड भरें",
  m_payout_fail: "भुगतान विवरण सहेजा नहीं जा सका",
  m_payout_after_save: "अपनी दुकान सहेजें, फिर बेचना शुरू करने के लिए भुगतान विवरण जोड़ें।",
  m_lifetime_net: "आजीवन कमाई",
  m_this_month: "इस माह",
  m_mark_shipped: "भेजा गया चिह्नित करें",
  m_mark_delivered: "डिलीवर चिह्नित करें",
  m_marked_shipped: "भेजा गया चिह्नित — खरीदार को सूचित किया",
  m_marked_delivered: "डिलीवर चिह्नित — खरीदार को सूचित किया",
  m_fs_processing: "तैयारी हो रही है",
  m_fs_shipped: "भेजा गया",
  m_fs_delivered: "डिलीवर हुआ",
  m_orders: "ऑर्डर",
  m_no_orders: "अभी कोई ऑर्डर नहीं",
  m_track_processing: "तैयारी हो रही है",
  m_track_shipped: "भेजा गया",
  m_track_delivered: "डिलीवर हुआ",
  m_track_refunded: "वापस किया गया",
  m_sell_coming_soon: "ऑनलाइन बिक्री जल्द आ रही है — थोड़ा रुकें!",
  m_delete: "हटाएं",
  m_plans_title: "प्लान (दुकान आकार के अनुसार)",
  m_up_to: "तक",
  m_items_suffix: "आइटम",
  m_can_sell: "ऑनलाइन बेच सकते हैं",
  m_display_only_low: "केवल प्रदर्शन",
  m_per_mo: "/माह",
  m_free: "मुफ़्त",
  m_current: "वर्तमान",
  m_subscribe: "सदस्यता लें",
  m_choose: "चुनें",
  m_my_items: "मेरे आइटम",
  m_dashboard: "डैशबोर्ड",
  m_active_items: "सक्रिय आइटम",
  m_archived: "आर्काइव किए",
  m_total_views: "कुल व्यू",
  m_messages: "संदेश",
  m_item_views_7d: "आइटम व्यू (पिछले 7 दिन)",
  m_buyer_msgs_7d: "खरीदार संदेश (पिछले 7 दिन)",
  m_boost: "बूस्ट",
  m_promote: "प्रचार करें",
  m_edit: "संपादित करें",
  m_repost: "फिर पोस्ट करें",
  m_no_items_yet: "अभी कोई आइटम नहीं",
  m_boost_item: "इस आइटम को बूस्ट करें",
  m_boost_desc_1: "पिन करें",
  m_boost_desc_2: "ब्राउज़ के शीर्ष पर। एक अवधि चुनें:",
  m_days: "दिन",
  m_no_boost_opts: "अभी कोई बूस्ट विकल्प कॉन्फ़िगर नहीं।",
  m_cancel: "रद्द करें",
  a_messages: "संदेश",
  a_online: "ऑनलाइन",
  a_open_feedback: "खुली प्रतिक्रिया",
  a_msgs_day: "संदेश / दिन (14 दिन)",
  a_newusers_day: "नए उपयोगकर्ता / दिन (14 दिन)",
  a_storage: "स्टोरेज",
  a_database: "डेटाबेस",
  a_media_files: "मीडिया फ़ाइलें",
  a_set_new_pw: "नया पासवर्ड सेट करें",
  a_new_pw_ph: "नया पासवर्ड (न्यूनतम 6 अक्षर)",
  a_save: "सहेजें",
  a_broadcast_desc_1: "यहाँ से भेजा",
  a_broadcast_desc_2: "हर उपयोगकर्ता को। प्राप्तकर्ता उत्तर नहीं दे सकते।",
  a_announcement_ph: "आपकी घोषणा…",
  a_remove: "हटाएं",
  a_image: "इमेज",
  a_file: "फ़ाइल",
  a_no_feedback: "अभी कोई प्रतिक्रिया नहीं",
  a_answered: "उत्तर दिया",
  a_reply_ph: "आपका उत्तर (RoyalChat Nova से)…",
  a_send: "भेजें",
  a_respond: "उत्तर दें",
  a_delete: "हटाएं",
  a_deleted: "हटाया गया",
  a_media_desc: "मीडिया स्टोरेज क्षेत्र के अनुसार विभाजित। जगह खाली करने के लिए पूरा क्षेत्र हटाएं।",
  a_loading: "लोड हो रहा है…",
  a_chat_media: "चैट मीडिया",
  a_social_media: "सोशल मीडिया",
  a_market_media: "मार्केटप्लेस मीडिया",
  a_files: "फ़ाइलें",
  a_currency: "मुद्रा",
  a_currency_note: "अब विक्रेता अपनी दुकान की मुद्रा चुनते हैं। शुल्क, कर और प्लान कीमतें USD में बिल की जाती हैं।",
  a_platform_fee: "प्लेटफ़ॉर्म शुल्क (%)",
  a_reports: "रिपोर्ट",
  a_no_reports: "कोई मार्केटप्लेस रिपोर्ट नहीं 🎉",
  a_report: "रिपोर्ट",
  a_warned: "चेतावनी दी",
  a_seller_suspended: "विक्रेता निलंबित",
  a_dismissed: "खारिज",
  a_seller: "विक्रेता",
  a_user_gone: "खाता हटाया गया",
  a_item: "आइटम",
  a_reason: "कारण",
  a_no_reason: "कोई कारण नहीं दिया",
  a_reported_by: "रिपोर्ट करने वाला",
  a_warn: "चेतावनी दें",
  a_unsuspend: "निलंबन हटाएं",
  a_suspend: "निलंबित करें",
  a_dismiss: "खारिज करें",
  a_confirm_suspend: "इस विक्रेता को निलंबित करें? उनकी दुकान और आइटम छिप जाएंगे और वे निलंबन हटने तक लॉक रहेंगे।",
  a_warn_sent: "विक्रेता को चेतावनी भेजी गई",
  a_suspended_ok: "विक्रेता निलंबित",
  a_unsuspended_ok: "विक्रेता फिर सक्रिय",
  a_dismissed_ok: "रिपोर्ट खारिज",
  a_commission: "प्लेटफ़ॉर्म कमीशन (%)",
  a_commission_note: "कमीशन प्रत्येक बिक्री से विक्रेता की ओर से लिया जाता है — खरीदार हमेशा सूचीबद्ध कीमत चुकाते हैं।",
  a_payout_setup: "विक्रेता भुगतान सेटअप",
  a_sell_shops: "बिक्री दुकानें",
  a_payout_done: "भुगतान तैयार",
  a_payout_pending: "लंबित",
  a_welcome_title: "स्वागत संदेश",
  a_welcome_desc: "पंजीकरण करते ही RoyalChat Nova से हर उपयोगकर्ता को अपने-आप भेजा जाता है।",
  a_welcome_from: "इस रूप में भेजा",
  a_welcome_lang_hint: "एक भाषा चुनें, फिर उस भाषा में पंजीकृत उपयोगकर्ताओं को दिखने वाला संदेश संपादित करें। खाली छोड़ी गई भाषाएँ अंग्रेज़ी पर वापस चली जाएँगी।",
  a_welcome_saved: "स्वागत संदेश सहेजा गया",
  a_on: "चालू",
  a_off: "बंद",
  a_tax_percent: "बिक्री कर (%)",
  a_sub_tiers: "सदस्यता स्तर (दुकान आकार के अनुसार)",
  a_max_items: "अधिकतम आइटम",
  a_price_mo: "कीमत /माह",
  a_can_sell_paid: "ऑनलाइन बेच सकते हैं (सशुल्क सुविधा)",
  a_listings_boost: "लिस्टिंग और बूस्ट",
  a_listing_duration: "लिस्टिंग अवधि (आइटम समाप्त होने से पहले के दिन)",
  a_boost_opts: "बूस्ट विकल्प (ब्राउज़ के शीर्ष पर आइटम पिन करें)",
  a_days: "दिन",
  a_price: "कीमत",
  a_categories: "श्रेणियाँ",
  a_cat_desc: "अल्पविराम से अलग सूची जिससे खरीदार फ़िल्टर कर सकें",
  a_save_market: "मार्केटप्लेस सेटिंग्स सहेजें",
  a_sellers_shops: "विक्रेता / दुकानें",
  a_items: "आइटम",
  a_subscribed: "सदस्यता ली",
  a_unverify: "सत्यापन हटाएं",
  a_verify: "सत्यापित करें",
  a_no_shops: "अभी कोई दुकान नहीं",
  a_terms_desc: "उपयोगकर्ताओं को दिखाई जाने वाली शर्तें संपादित करें (चैट, सोशल और मार्केटप्लेस शामिल)। Markdown शैली: शीर्षकों के लिए # और ## उपयोग करें।",
  a_save_terms: "शर्तें सहेजें",
  a_free_space: "अभी जगह खाली करें",
  a_what_delete: "क्या हटाना है",
  a_select_all: "सभी चुनें",
  a_clear: "साफ़ करें",
  a_images: "इमेज",
  a_videos: "वीडियो",
  a_audio: "ऑडियो",
  a_documents: "दस्तावेज़",
  a_scope: "दायरा",
  a_older_than: "इससे पुराना…",
  a_delete_all: "सब हटाएं",
  a_delete_older_days: "इससे पुराने आइटम हटाएं (दिन)",
  a_delete_all_warn: "⚠️ यह प्रत्येक चयनित आइटम को उसकी उम्र की परवाह किए बिना स्थायी रूप से हटा देता है। इसे पूर्ववत नहीं किया जा सकता।",
  a_also_delete_files: "सहेजी फ़ाइलें भी हटाएं (सबसे अधिक जगह खाली करता है)",
  a_running: "चल रहा है…",
  a_delete_all_now: "अभी सब चयनित हटाएं",
  a_run_cleanup: "अभी सफ़ाई चलाएं",
  a_sched_cleanup: "शेड्यूल की सफ़ाई (दैनिक)",
  a_autodelete_days: "इससे पुराने अपने-आप हटाएं (दिन)",
  a_save_schedule: "शेड्यूल सहेजें",
  a_custom_invite: "कस्टम आमंत्रण संदेश",
  a_save_message: "संदेश सहेजें",
  a_load_failed: "एडमिन लोड विफल",
  a_failed: "विफल",
  a_market_saved: "मार्केटप्लेस सेटिंग्स सहेजी गईं",
  a_terms_saved: "शर्तें सहेजी गईं",
  a_verified: "सत्यापित",
  a_unverified: "असत्यापित",
  a_updated: "अपडेट हुआ",
  a_delete_user_q: "उपयोगकर्ता हटाएं?",
  a_pw_min: "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
  a_pw_updated: "पासवर्ड अपडेट हुआ",
  a_pw_fail: "पासवर्ड अपडेट नहीं हो सका",
  a_upload_failed: "अपलोड विफल",
  a_reply_sent: "उत्तर भेजा गया",
  a_pick_category: "हटाने के लिए कम से कम एक श्रेणी चुनें",
  a_schedule_saved: "शेड्यूल सहेजा गया",
  a_invite_saved: "आमंत्रण संदेश सहेजा गया",
  a_confirm_del_media: "इस क्षेत्र की सभी मीडिया फ़ाइलें हटाएं? इसे पूर्ववत नहीं किया जा सकता।",
  a_files_deleted: "फ़ाइलें हटाई गईं",
  a_confirm_cleanup: "चयनित मीडिया हटाएं? इसे पूर्ववत नहीं किया जा सकता।",
  a_removed: "हटाया गया",
  a_sent_broadcast: "प्रसारण भेजा गया",
  ss_title: "सोशल सेटिंग्स",
  ss_desc: "कुछ समय बाद मेरी पोस्ट अपने-आप हटाएं। यह आपकी फ़ीड को व्यवस्थित रखता है — यह केवल आपकी अपनी पोस्ट पर लागू होता है।",
  ss_saved: "सहेजा गया",
  ss_never: "कभी नहीं (हमेशा रखें)",
  ss_1m: "1 माह बाद",
  ss_3m: "3 माह बाद",
  ss_6m: "6 माह बाद",
  ss_12m: "12 माह बाद",
  set_available: "RoyalChat Nova पर उपलब्ध",
  set_invite_title: "दोस्तों को आमंत्रित करें",
  set_invite_desc: "RoyalChat Nova अपने संपर्कों के साथ शेयर करें",
  set_suggest_title: "एक सुझाव भेजें",
  set_suggest_desc: "हमें बेहतर बनाने में मदद करें — एक स्क्रीनशॉट जोड़ें",
  set_away_title: "अनुपस्थिति-ईमेल अलर्ट",
  set_social_market: "सोशल और मार्केटप्लेस",
  set_social_desc: "पुरानी पोस्ट अपने-आप हटाएं और अधिक",
  set_market_desc: "अपनी दुकान, आइटम और डैशबोर्ड प्रबंधित करें",
  set_terms_desc: "चैट, सोशल और मार्केटप्लेस",
  set_installed: "ऐप इंस्टॉल हुआ",
  set_installed_toast: "इंस्टॉल हुआ ✓",
  set_ios_install: "Safari: शेयर ← होम स्क्रीन में जोड़ें",
  set_browser_install: "ब्राउज़र मेनू ← ऐप इंस्टॉल करें",
  set_not_supported: "इस डिवाइस पर समर्थित नहीं",
  set_notif_fail: "सूचनाएँ चालू नहीं हो सकीं",
  m_photos_max: "फ़ोटो (5 तक)",
  m_add_video: "वीडियो जोड़ें",
  m_video: "प्रदर्शन वीडियो",
  m_remove_video: "वीडियो हटाएं",
  m_stock_label: "स्टॉक मात्रा",
  m_stock_ph: "असीमित के लिए खाली छोड़ें",
  m_variants: "वैरिएंट (रंग, आकार…)",
  m_add_option: "विकल्प जोड़ें",
  m_option_name_ph: "विकल्प नाम (जैसे रंग)",
  m_option_values_ph: "मान, अल्पविराम से अलग (जैसे लाल, नीला)",
  m_variant_stock: "प्रति विकल्प स्टॉक",
  m_promo: "प्रोमोशन",
  m_promo_price: "प्रोमो कीमत",
  m_promo_days: "प्रोमो चलता है (दिन)",
  m_off: "छूट",
  m_ends_in: "समाप्त होगा",
  m_day_short: "दि",
  m_only_left: "केवल {n} बचे",
  m_more_from_shop: "इस दुकान से और",
  m_select_options: "विकल्प चुनें",
  m_shop_avatar: "दुकान अवतार (छोटा)",
  m_shop_banner: "दुकान बैनर (बड़ा)",
  m_upload_photo: "अपलोड",
  m_change_photo: "बदलें",
  m_featured_shops: "विशेष दुकानें",
  m_recently_viewed: "हाल में देखे",
  m_shop_items: "आइटम",
  m_shop_no_items: "इस दुकान में अभी कोई आइटम नहीं",
  m_cart_empty: "आपकी कार्ट खाली है",
  m_cart_empty_hint: "आइटम ब्राउज़ करें और यहाँ जोड़ें",
  m_choose_options_first: "पहले विकल्प चुनें",
  m_processing: "प्रोसेस हो रहा है…",
};

export const zh = {
  safe_trade_title: "安全交易", safe_trade_dismiss: "知道了",
  safe_tip_1: "本地交易请在人多的公共场所见面。",
  safe_tip_2: "付款前请当面检查商品。",
  safe_tip_3: "切勿提前付款，也不要分享 OTP / 银行卡 / PIN 码。",
  safe_tip_4: "价格好得不真实时要提高警惕。",
  scam_warning: "存在高风险付款要求。切勿提前付款或分享任何验证码。",
  scam_compose_warning: "这看起来有风险。保持警惕——避免提前付款和分享验证码。",
  photo_tips: "拍照技巧", photo_tips_title: "好照片卖得更快",
  photo_tip_1: "在明亮的自然光下拍摄。",
  photo_tip_2: "展示商品的多个角度。",
  photo_tip_3: "使用干净、整洁的背景。",
  photo_tip_4: "如实展示瑕疵以建立信任。",
  photo_tip_5: "让商品充满画面——靠近拍摄。",
  help_guide: "指南", guide_got_it: "知道了", coming_soon: "即将推出",
  guide_social_title: "社交页导览",
  guide_social_1: "动态——好友和关注对象的帖子。可切换到发现。",
  guide_social_2: "好友——查找用户、接受请求并发现新朋友。",
  guide_social_3: "收件箱——私信，现支持照片、视频和语音。",
  guide_social_4: "我——你的资料、帖子和数据。帖子 ⋯ 菜单可关注、分享或举报。",
  guide_market_title: "商城导览",
  guide_market_1: "浏览——搜索商品，点击卡片查看详情。",
  guide_market_2: "收藏——你收藏以便稍后查看的商品。",
  guide_market_3: "我的店铺——发布商品、开展促销并管理店铺。",
  guide_market_4: "收件箱——与买家或卖家沟通。注意金色 ✔ 认证卖家徽章。",
  open_app: "打开应用", get_started: "开始", install: "安装 RoyalChat Nova", download_royalchat: "下载 RoyalChat Nova",
  login: "登录", register: "创建账户", email: "邮箱", password: "密码",
  name: "全名", chats: "消息", search: "搜索聊天…", new_chat: "新聊天",
  settings: "设置", logout: "退出登录", type_message: "输入消息…",
  pinned: "已置顶", all_chats: "所有聊天", online: "在线", typing: "正在输入…",
  pin: "置顶", schedule: "定时",
  no_chats: "还没有对话", start_conversation: "开始对话",
  profile: "个人资料", theme: "主题", language: "语言", dark: "深色", light: "浅色",
  ai_assistant: "AI 助手", admin: "管理员", read_aloud: "朗读",
  admin_panel_desc: "管理用户、媒体和广播",
  tab_chats: "聊天", tab_calls: "通话", tab_settings: "设置", tab_social: "社交", tab_market: "市场",
  appearance: "外观", preferences: "偏好", network: "网络", connected: "已连接",
  notifications: "通知", edit_profile: "编辑资料", phone: "电话号码",
  data_usage: "流量使用", used_today: "今日已用",
  country: "国家", about: "关于", change_password: "修改密码", save: "保存", cancel: "取消",
  pw_current: "当前密码", pw_new: "新密码", pw_update: "更新密码", pw_updated: "密码已更新 ✓", pw_fill_both: "请输入当前密码和新密码", pw_too_short: "新密码至少需要 6 个字符", pw_change_failed: "无法修改密码",
  auto_download: "媒体自动下载", auto_download_desc: "选择哪些媒体自动下载", mt_images: "图片", mt_audio: "音频", mt_video: "视频", mt_documents: "文档",
  clear_media_title: "清除已存媒体？", clear_media_warn: "这将永久删除本设备上所有已下载的照片、视频、音频和文档。下次打开时会重新下载。", clear_media_confirm: "清除",
  welcome_back: "欢迎回来", signin_continue: "登录以继续您的对话。",
  join_royalchat: "加入 RoyalChat Nova", create_seconds: "几秒内创建您的账户。",
  forgot_password: "忘记密码？", new_here: "初次使用 RoyalChat Nova？", already_account: "已有账户？",
  email_or_phone: "邮箱或电话号码", continue_google: "使用 Google 继续", or_divider: "或",
  search_country: "搜索国家…", no_results: "无结果", today: "今天", yesterday: "昨天",
  create_account_cta: "创建账户", login_tagline: "让对话变得尊贵",
  reply: "回复", you: "你", copy: "复制", delete: "删除", open: "打开", download: "下载", copied: "已复制",
  forward: "转发", forward_to: "转发给", forwarded: "已转发", this_chat: "此聊天",
  block: "屏蔽", unblock: "取消屏蔽",
  land_badge: "尊享级消息体验", land_hero_1: "让每一次对话都", land_hero_accent: "尊贵非凡",
  land_nav_features: "功能", land_nav_install: "安装", land_terms: "条款与条件",
  land_pillars_title: "聊天与连接 — 一站搞定",
  land_p1_t: "消息与通话", land_p2_t: "社交动态", land_p3_t: "市场",
  s_social: "社交", s_feed: "动态", s_friends: "好友", s_inbox: "收件箱", s_me: "我",
  s_loading: "加载中…", s_no_posts: "还没有帖子。快来第一个分享吧！👑",
  s_failed: "失败", s_request_sent: "请求已发送", s_requests: "请求", s_discover: "发现", s_now: "刚刚",
  s_search_people: "搜索用户…", s_add: "添加", s_sent: "已发送",
  s_like: "点赞", s_reply: "回复", s_write_comment: "写评论…", s_write_reply: "写回复…",
  s_read_more: "阅读更多", s_read_less: "收起", s_views: "次浏览", s_post: "发布", s_whats_mind: "在想什么？",
  s_add_photo: "照片", s_add_video: "视频", s_add_audio: "音频", s_add_document: "文档", s_take_photo: "相机",
  s_following: "关注中", s_follow: "关注", s_unfollow: "取消关注", s_now_following: "已关注", s_message: "私信", s_send: "发送",
  s_followers: "粉丝", s_posts: "帖子", s_following_label: "关注", s_back: "返回", s_cancel: "取消",
  s_share_post: "分享帖子…", s_copy_link: "复制链接", s_delete_post: "删除帖子", s_report_post: "举报帖子",
  go_live: "开始直播", your_story: "你的动态", live_badge: "直播", live_now: "正在直播", s_watch: "观看", live_ended: "直播已结束",
  live_say_something: "说点什么…", live_now_strip: "正在直播", live_full: "直播间已满", live_buy: "购买", s_close: "关闭",
  live_schedule_for_later: "稍后开播", live_when_label: "日期和时间", live_upcoming: "即将开播",
  live_notify_me: "提醒我", live_notifying: "将提醒你", live_scheduled_ok: "直播已预约", live_go_now: "立即开播",
  live_starts_in: "开始于", live_starting_soon: "即将开始", live_title_label: "标题（可选）",
  live_max_label: "最大观众数（可选）", live_pin_product: "置顶商品", live_end_btn: "结束直播",
  live_filter_none: "无", live_filter_soft: "柔和", live_filter_warm: "暖色", live_filter_cool: "冷色", live_filter_vivid: "鲜艳", live_filter_mono: "黑白",
  share: "分享", share_to_timeline: "分享到我的主页", share_in_chat: "发送到聊天", share_copy_link: "复制链接",
  share_more: "更多…", share_link_copied: "链接已复制", share_sent: "已发送", share_join_btn: "加入 RoyalChat Nova",
  share_join_cta: "加入 RoyalChat Nova 查看更多并联系卖家。", share_not_found: "该内容已不可用。", m_view_product: "查看商品",
  m_market: "市场", m_browse: "浏览", m_saved: "已保存", m_my_shop: "我的店铺", m_inbox: "收件箱",
  m_search_items: "搜索商品…", m_all: "全部", m_message: "私信", m_add_to_cart: "加入购物车", m_added_to_cart: "已加入购物车",
  m_title: "标题", m_price: "价格", m_description: "描述", m_category: "分类", m_location: "位置",
  m_list_item: "发布商品", m_edit_item: "编辑商品", m_publish: "发布商品", m_save_changes: "保存更改",
  m_add_photos: "添加照片", m_take_photo: "相机", m_seller: "卖家", m_message_seller: "联系卖家",
  m_cart: "购物车", m_checkout: "结算", m_subtotal: "小计", m_tax: "税费", m_total: "总计", m_remove: "移除",
  m_visit_shop: "访问店铺", m_in_stock: "有货", m_out_of_stock: "缺货", m_qty: "数量", m_each: "每件",
  m_edit_shop: "编辑店铺", m_shop_name: "店铺名称", m_save_shop: "保存店铺", m_add_item: "添加商品",
  a_dashboard: "管理后台", a_overview: "概览", a_users: "用户", a_broadcast: "广播", a_feedback: "反馈",
  a_media: "媒体", a_market: "市场", a_terms: "条款", a_cleanup: "清理", a_permissions: "分区权限",
  set_social_title: "社交设置", set_market_title: "市场设置", set_terms_title: "条款与条件",
  help_support: "帮助与支持", blocked_contacts: "已屏蔽联系人", verify_email: "验证我的邮箱",
  st_new_story: "新故事", st_camera: "相机", st_camera_sub: "照片或视频", st_gallery: "相册", st_gallery_sub: "从设备上传", st_text: "文字", st_text_sub: "在背景上书写",
  st_type_something: "输入内容…", st_sticker: "贴纸", st_poll: "投票", st_ask: "提问", st_link: "链接", st_draw: "涂鸦", st_music: "音乐",
  st_undo: "撤销", st_clear: "清除", st_done: "完成", st_add_caption: "添加说明…", st_public: "公开", st_friends: "好友", st_close_friends: "密友",
  st_also_share: "同时分享到动态", st_post_story: "发布故事", st_add_poll: "添加投票", st_ask_question: "提出问题", st_add_link: "添加链接",
  st_question_opt: "问题（可选）", st_option1: "选项 1", st_option2: "选项 2", st_ask_me: "问我任何事", st_btn_label: "按钮文字（可选）",
  st_cancel: "取消", st_add: "添加", st_visit_link: "查看链接", st_uploading: "上传中…", st_upload_own: "上传自己的",
  st_your_story: "你的故事", st_views: "次浏览", st_view: "次浏览", st_reply_to: "回复", st_insights: "数据", st_story_insights: "故事数据",
  st_replies: "回复", st_reactions: "互动", st_no_answers: "暂无回答", st_viewers: "浏览者", st_no_viewers: "暂无浏览",
  st_replies_in_insights: "回复会显示在你的数据里", st_sent: "已发送 ✨", st_type_short: "输入…",
  st_new_highlight: "新的精选", st_hl_name_ph: "名称（如 旅行、家庭）", st_hl_cover_hint: "点击圆圈设置自定义封面（可选——否则使用第一条故事）。",
  st_hl_choose: "选择要加入的故事", st_hl_selected: "已选", st_hl_none: "你还没有故事。请先发布一条，再保存到这里。",
  st_save_highlight: "保存精选", st_new: "新建", st_edit: "编辑",
  st_story_posted: "故事已发布 ✨", st_post_failed: "无法发布故事", st_music_added: "已添加音乐 🎵", st_upload_failed: "上传失败",
  st_two_options: "请添加两个选项", st_enter_url: "请输入网址", st_hl_saved: "精选已保存 ⭐", st_pick_story: "至少选择一条故事",
  st_cover_failed: "封面上传失败", st_hl_deleted: "精选已删除", st_cover_updated: "封面已更新", st_order_saved: "顺序已保存", st_failed: "失败",
  st_reply_sent: "回复已发送", st_story_deleted: "故事已删除", st_empty_highlight: "该精选为空", st_delete_story_q: "删除这条故事？", st_delete_hl_q: "删除这个精选？",
  call_voice: "语音通话", call_video: "视频通话", call_missed_voice: "未接语音通话", call_missed_video: "未接视频通话",
  call_failed: "通话失败", call_no_answer: "无人接听", call_try_again: "重试", call_tap_back: "点按回拨", call_min: "分钟", call_sec: "秒",
  call_lbl_mute: "静音", call_lbl_unmute: "取消静音", call_lbl_speaker: "扬声器", call_lbl_headset: "耳机", call_lbl_camera: "摄像头", call_lbl_flip: "翻转", call_lbl_saver: "省流量", call_lbl_end: "结束", call_lbl_answer: "接听", call_lbl_decline: "拒绝", call_lbl_fullscreen: "全屏", call_lbl_normal: "普通",

  // --- Completed translations (auto-added) ---
  ultra_lite: "超轻模式",
  ultra_lite_desc: "仅文字：媒体点按加载，关闭链接预览",
  auto_delete_media: "自动删除媒体",
  auto_delete_desc: "清除超过此时长的已存媒体以释放空间",
  app_lock: "应用锁",
  app_lock_desc: "打开应用需输入 PIN 码",
  app_lock_on: "已开启 · 打开需 PIN 码",
  notifications_on: "通知已启用",
  notifications_blocked: "通知已被屏蔽",
  ios_install_for_push: "在 iPhone 上：点按 分享 ← 添加到主屏幕，然后从主屏幕打开 RoyalChat Nova 以启用通知。",
  or_pick_avatar: "或选择一个头像",
  calls: "通话",
  all: "全部",
  missed: "未接",
  no_calls: "还没有通话",
  configure_ai: "配置 AI",
  get_free_key: "获取免费密钥",
  how_get_key: "如何获取你的密钥（1 分钟，无需银行卡）",
  reset_pw_title: "重置密码",
  reset_pw_desc: "输入你的邮箱以接收重置链接。",
  send_reset: "发送重置链接",
  back_login: "返回登录",
  back_home: "返回首页",
  readonly_notice: "这是 RoyalChat Nova 官方频道——你无法在此回复。",
  channel_readonly_notice: "只有管理员可以在此频道发布内容。",
  create_account_title: "创建\n你的账户",
  create_account_sub: "加入 RoyalChat Nova 开始聊天",
  complete_profile_prompt: "添加你的国家和电话，好友才能找到你并给你打电话。",
  complete_profile_cta: "完善资料",
  dismiss: "忽略",
  remove_key: "移除密钥",
  key_removed: "密钥已移除",
  attach_photos: "照片",
  attach_document: "文档",
  attach_sticker: "贴纸",
  attach_camera: "相机",
  poll: "投票",
  read_receipts: "已读回执",
  read_receipts_desc: "阅读消息时显示蓝色对勾",
  sending_tap_cancel: "发送中…点按取消",
  recording: "录制中…",
  data_storage: "数据与存储",
  data_saver: "省流量模式",
  data_saver_desc: "大幅压缩照片、音频和视频",
  autodl_off: "从不",
  autodl_wifi: "仅 Wi-Fi",
  autodl_always: "始终",
  undo_send_title: "发送前撤回",
  undo_send_desc: "延迟消息，以便你可以取消",
  storage_cleanup: "清除已存媒体",
  storage_cleanup_desc: "移除本设备上保存的照片、音频和文档",
  storage_cleared: "存储已清除",
  help_support_desc: "常见问题及如何获取帮助",
  privacy_help: "隐私与帮助",
  sounds_ringtones: "声音与铃声",
  sound_effects: "音效",
  sound_effects_desc: "为发送、接收和通话播放提示音",
  tone_sent: "已发送消息",
  tone_received: "已接收消息",
  tone_call: "来电",
  verified: "已认证",
  not_verified: "未认证",
  verify_email_desc: "为你的账户获得认证徽章",
  verify_intro: "我们将向你的邮箱发送一个 6 位验证码以确认是你本人。",
  verify_send_code: "发送验证码",
  verify_enter_code: "输入我们发送到你邮箱的 6 位验证码",
  verify_confirm: "验证邮箱",
  verify_success: "邮箱已验证",
  verify_code_sent: "验证码已发送到你的邮箱",
  verify_invalid: "验证码无效或已过期",
  verify_resend: "重新发送验证码",
  already_verified: "你的邮箱已验证",
  blocked_contacts_desc: "管理你已屏蔽的人",
  no_blocked: "你还没有屏蔽任何人",
  block_contact: "屏蔽联系人",
  blocked_toast: "已屏蔽联系人",
  unblocked_toast: "已取消屏蔽联系人",
  tap_to_download: "点按下载",
  poor_connection_quality: "连接较差 · 质量已降低",
  call_reconnecting: "正在重新连接…",
  messages_label: "条消息",
  one_message_label: "1 条消息",
  forwarded_label: "已转发",
  load_older: "加载更早的消息",
  loading_older: "加载中…",
  jump_to_latest: "跳到最新",
  land_hero_sub: "一款精心打造的消息应用——精致的通话、智能的助手，以及每个细节中金牌级的体验。优雅、轻松、可安装。",
  land_cap_label: "功能",
  land_cap_title: "你需要的一切，绝不拖慢你",
  land_f1_t: "无可挑剔的精致",
  land_f1_d: "精心打造的界面，每次交互都高人一等。",
  land_f2_t: "水晶般清晰的通话",
  land_f2_d: "高清 1:1 和群组音视频通话，配以优雅的通话内控件。",
  land_f3_t: "AI 助手",
  land_f3_d: "自带 Groq / Gemini / OpenRouter 密钥。快速提示、语音听写、文档分析。",
  land_f4_t: "贴纸与媒体",
  land_f4_d: "动态贴纸、图片与视频相册、语音笔记和文档——精美呈现。",
  land_f5_t: "群组与管理员",
  land_f5_d: "创建群组、管理成员和管理员，带邀请者姓名的个性化邀请。",
  land_f6_t: "可安装的 PWA",
  land_f6_d: "在 Android 和 iOS 上将 RoyalChat Nova 添加到主屏幕，获得真正的原生应用体验。",
  land_how_label: "工作原理",
  land_how_title: "为轻松无感而设计",
  land_s1_t: "一键安装",
  land_s1_d: "将 RoyalChat Nova 添加到主屏幕——无需应用商店，毫不杂乱。",
  land_s2_t: "有格调地畅聊",
  land_s2_d: "在精致的黑底金色界面中进行丰富的实时对话。",
  land_s3_t: "一切集于一处",
  land_s3_d: "通话、群组、媒体和 AI 助手——优雅地触手可及。",
  land_crafted: "为尊享体验而打造",
  land_inside_label: "内部一览",
  land_inside_title: "设计尊贵，使用轻松",
  land_mock_chats: "聊天",
  land_mock_convo: "对话",
  land_mock_ai: "AI 助手",
  land_mock_talk_soon: "回聊 👑",
  land_mock_design: "设计团队",
  land_mock_design_msg: "Kwame：已发布 ✅",
  land_mock_mother: "妈妈",
  land_mock_mother_msg: "今晚给我打电话",
  land_mock_msg1: "这个应用感觉太高级了 ✨",
  land_mock_msg2: "只为你呈现最好的 👑",
  land_mock_ai_desc: "什么都能问。总结文档。用语音听写——使用你自己的密钥。",
  land_install_title: "安装 RoyalChat Nova",
  land_install_sub: "获得完整应用体验——主屏幕图标、离线外壳和推送通知。",
  land_install_now: "立即安装",
  land_installed: "已安装",
  land_iphone: "在 iPhone 上（Safari 16.4+）",
  land_iphone_tap: "点按",
  land_iphone_add: "添加到主屏幕",
  land_native_apps: "原生应用",
  land_download_on: "下载于",
  land_coming_soon: "即将推出",
  land_pillars_label: "一个应用 · 两个世界",
  land_p1_d: "快速的 1:1 和群组聊天、媒体相册、语音笔记和水晶般清晰的音视频通话——即使在弱 4G 下也能运行。",
  land_p1_c1: "群组",
  land_p1_c2: "通话",
  land_p1_c3: "离线可用",
  land_p2_d: "发布照片、点赞、评论和分享。添加好友、关注他人，并在与聊天分开的社交收件箱中私信他们。",
  land_p2_c1: "好友",
  land_p2_c2: "关注",
  land_p2_c3: "动态",
  land_p3_d: "开一家店铺，用照片和价格发布商品，推广商品并接收买家消息——在线销售或仅作展示。",
  land_p3_c1: "店铺",
  land_p3_c2: "心愿单",
  land_p3_c3: "评价",
  s_friend_added: "已添加好友",
  s_no_friends: "还没有好友——去发现用户吧！",
  s_no_requests: "没有好友请求",
  s_no_people: "未找到用户",
  s_link_copied: "链接已复制",
  s_check_post: "看看这条帖子",
  s_deleted: "已删除",
  s_could_not_delete: "无法删除",
  s_could_not_upload: "无法上传图片",
  s_posted: "已发布 🎉",
  s_could_not_post: "无法发布",
  s_public: "公开",
  s_could_not_upload_media: "无法上传文件",
  s_document: "文档",
  s_no_following_posts: "还没有好友或你关注对象的帖子。",
  s_reactions: "互动",
  s_replying_to: "正在回复",
  s_view_replies: "查看 {n} 条回复",
  s_hide_replies: "隐藏回复",
  s_reshare: "转发到我的主页",
  s_reshared: "已转发",
  s_block_user: "屏蔽此用户",
  s_reshared_toast: "已转发到你的主页",
  s_user_blocked: "用户已屏蔽",
  s_reported: "帖子已举报——谢谢",
  s_unfollowed: "已取消关注",
  s_select: "选择",
  s_select_all: "全选",
  s_message_selected: "私信（{n}）",
  s_write_message: "写一条消息…",
  s_broadcast_sent: "已发送给 {n} 人",
  s_no_followers: "还没有粉丝。",
  s_no_following: "你还没有关注任何人。",
  live_starting: "正在开始你的直播…",
  live_connecting: "正在连接直播…",
  live_cam_fail: "摄像头/麦克风不可用",
  live_join_fail: "无法加入直播",
  live_cam_switch_fail: "无法切换摄像头",
  live_schedule_live: "预约直播",
  live_soon_toast: "即将开播",
  live_when_required: "请选择日期和时间",
  live_cancel_sched_q: "取消这个预约的直播？",
  live_title_ph: "你的直播是关于什么的？",
  live_max_ph: "留空表示不限",
  live_replay_caption: "🔴 直播回放",
  live_replay_posted: "回放已发布到你的动态",
  live_post_replay_q: "将此直播保存为回放发布到你的动态？",
  live_posting_replay: "正在发布回放…",
  share_caption_ph: "说点什么…",
  share_to_timeline_ok: "已分享到你的主页",
  s_no_messages: "还没有消息",
  s_message_friend: "从好友的资料页给他发消息",
  s_message_ph: "消息…",
  s_confirm_delete_social: "删除你的全部社交数据（帖子、好友、关注、消息）？此操作无法撤销。",
  s_social_deleted: "社交数据已删除",
  s_requested: "已请求",
  s_accept: "接受",
  s_add_friend: "添加好友",
  s_no_posts_yet: "还没有帖子",
  s_delete_my_data: "删除我的社交数据",
  s_delete_my_data_desc: "移除你的所有帖子、评论、好友、关注和社交消息。你的聊天账户保留。",
  m_no_items: "还没有商品——打开你的店铺发布点什么吧！",
  m_no_saved: "还没有收藏的商品——点按任意商品上的爱心",
  m_link_copied: "链接已复制",
  m_saved_wishlist: "已加入心愿单",
  m_removed: "已移除",
  m_boosted: "已推广",
  m_no_buyer_msgs: "还没有买家/卖家消息",
  m_message_seller_from: "从任意商品给卖家发消息",
  m_message_seller_ph: "给卖家发消息…",
  m_add_title: "添加标题",
  m_updated: "已更新",
  m_listed: "已发布",
  m_could_not_save: "无法保存",
  m_upload_failed: "上传失败",
  m_select: "选择…",
  m_photos_left: "张照片可添加",
  m_photos_full: "已达上限 5 张照片",
  m_ph_title: "例如 手工编织篮",
  m_ph_category: "家居",
  m_ph_location: "基加利",
  m_loading: "加载中…",
  m_saved_toast: "已保存",
  m_pick_star: "请选择星级评分",
  m_thanks_review: "感谢你的评价！",
  m_contact_price: "价格请咨询",
  m_ratings_reviews: "评分与评价",
  m_rate_shop: "为这家店铺评分",
  m_write_review: "写一条评价（可选）",
  m_submit_review: "提交评价",
  m_you_rated: "你已为这家店铺评分",
  m_no_reviews: "还没有评价。",
  m_name_shop: "为你的店铺命名",
  m_shop_saved: "店铺已保存",
  m_confirm_delete_shop: "删除你的店铺及其所有商品？此操作无法撤销。",
  m_shop_deleted: "店铺已删除",
  m_moved_archive: "已移至归档",
  m_reposted: "已重新发布 30 天",
  m_confirm_remove_item: "从数据库永久移除此商品？",
  m_promoted: "已推广到你的社交动态！🎉",
  m_could_not_promote: "无法推广",
  m_could_not_boost: "无法开始推广",
  m_plan_updated: "套餐已更新",
  m_could_not_checkout: "无法开始结算",
  m_open_shop: "开设你的店铺",
  m_what_sell: "你卖什么？",
  m_shop_location: "位置（例如 基加利）",
  m_subscribe_to_sell: "订阅下方的销售套餐以在线销售",
  m_just_display: "仅展示",
  m_sell_online_locked: "在线销售 🔒",
  m_sell_online: "在线销售",
  m_plan_lets_sell: "你的套餐允许你在线销售。",
  m_selling_requires: "销售需要付费套餐（见下方套餐）。展示是免费的。",
  m_selling_online: "正在在线销售",
  m_display_only: "仅展示",
  m_starter: "入门",
  m_pick_category_shop: "为你的店铺选择一个分类",
  m_add_location_shop: "添加你的店铺位置",
  m_shop_ready: "你的店铺已完成 {n}%",
  m_banner_hint: "横幅——1200×400px 效果最佳",
  m_avatar_hint: "标志——正方形，400×400px 最好看",
  m_currency: "货币",
  m_shop_location_short: "位置",
  m_see_plans: "查看套餐",
  m_plans_save_first: "请先保存你的店铺，再订阅销售套餐。",
  m_almost_there: "就差一点——只需添加：{fields}",
  m_golive_desc: "向你的买家进行直播——即将推出",
  m_report_chat: "举报给管理员",
  m_report_desc: "将你与 {name} 的聊天标记给 RoyalChat Nova 团队。他们会进行审核。",
  m_report_reason_ph: "出了什么问题？（可选）——例如要求在应用外付款",
  m_report_submit: "举报给管理员",
  m_report_sent: "已举报给管理员——谢谢",
  m_reason_offapp: "要求在应用外付款",
  m_reason_fake: "虚假 / 诈骗商品",
  m_reason_noshow: "未出现 / 未交货",
  m_reason_harassment: "骚扰",
  m_reason_other: "其他",
  m_text_seller: "联系卖家",
  m_sales: "销售",
  m_no_sales: "还没有销售",
  m_paid: "已付款",
  m_refunded: "已退款",
  m_sale_total: "销售总额",
  m_commission: "佣金",
  m_you_receive: "你获得",
  m_refund_buyer: "退款给买家",
  m_confirm_refund: "退款给此买家？此操作无法撤销。",
  m_refund_issued: "退款已发出",
  m_payout_saved: "收款信息已保存——你现在可以销售了",
  m_payout_ready: "款项将转至 {method}",
  m_payout_needed: "添加你的收款方式以开始销售",
  m_sell_pending: "销售待处理——请完成收款设置",
  m_payout_active: "收款已启用",
  m_payout_receive_at: "你的收款账户",
  m_payout_incomplete: "收款设置未完成",
  m_selling_pending_short: "销售中（收款待处理）",
  m_payout_title: "收款信息",
  m_payout_receive_note: "这里是你收取销售款项的地方——不会向你收费。",
  m_payout_card: "银行卡",
  m_payout_bank: "银行",
  m_payout_card_name: "持卡人姓名",
  m_payout_card_number: "卡号",
  m_payout_exp: "有效期",
  m_payout_cvv: "CVV",
  m_payout_acct_name: "账户持有人姓名",
  m_payout_bank_name: "银行名称",
  m_payout_acct_number: "账号",
  m_payout_routing: "路由 / 分行代码",
  m_payout_save: "保存并开始销售",
  m_payout_secure_note: "我们仅保存掩码后的引用（例如 •••• 4242）。真实收款将在连接服务商后启用。",
  m_payout_fill: "请填写所有字段",
  m_payout_fail: "无法保存收款信息",
  m_payout_after_save: "先保存你的店铺，再添加收款信息以开始销售。",
  m_lifetime_net: "累计收入",
  m_this_month: "本月",
  m_mark_shipped: "标记为已发货",
  m_mark_delivered: "标记为已送达",
  m_marked_shipped: "已标记为已发货——已通知买家",
  m_marked_delivered: "已标记为已送达——已通知买家",
  m_fs_processing: "备货中",
  m_fs_shipped: "已发货",
  m_fs_delivered: "已送达",
  m_orders: "订单",
  m_no_orders: "还没有订单",
  m_track_processing: "备货中",
  m_track_shipped: "已发货",
  m_track_delivered: "已送达",
  m_track_refunded: "已退款",
  m_sell_coming_soon: "在线销售即将推出——敬请期待！",
  m_delete: "删除",
  m_plans_title: "套餐（按店铺规模）",
  m_up_to: "最多",
  m_items_suffix: "件商品",
  m_can_sell: "可在线销售",
  m_display_only_low: "仅展示",
  m_per_mo: "/月",
  m_free: "免费",
  m_current: "当前",
  m_subscribe: "订阅",
  m_choose: "选择",
  m_my_items: "我的商品",
  m_dashboard: "仪表盘",
  m_active_items: "在售商品",
  m_archived: "已归档",
  m_total_views: "总浏览量",
  m_messages: "消息",
  m_item_views_7d: "商品浏览量（最近 7 天）",
  m_buyer_msgs_7d: "买家消息（最近 7 天）",
  m_boost: "推广",
  m_promote: "推广",
  m_edit: "编辑",
  m_repost: "重新发布",
  m_no_items_yet: "还没有商品",
  m_boost_item: "推广此商品",
  m_boost_desc_1: "置顶",
  m_boost_desc_2: "到浏览页顶部。选择一个时长：",
  m_days: "天",
  m_no_boost_opts: "还未配置任何推广选项。",
  m_cancel: "取消",
  a_messages: "消息",
  a_online: "在线",
  a_open_feedback: "待处理反馈",
  a_msgs_day: "消息 / 天（14 天）",
  a_newusers_day: "新用户 / 天（14 天）",
  a_storage: "存储",
  a_database: "数据库",
  a_media_files: "媒体文件",
  a_set_new_pw: "设置新密码",
  a_new_pw_ph: "新密码（至少 6 个字符）",
  a_save: "保存",
  a_broadcast_desc_1: "发送自",
  a_broadcast_desc_2: "至每位用户。接收者无法回复。",
  a_announcement_ph: "你的公告…",
  a_remove: "移除",
  a_image: "图片",
  a_file: "文件",
  a_no_feedback: "还没有反馈",
  a_answered: "已回复",
  a_reply_ph: "你的回复（来自 RoyalChat Nova）…",
  a_send: "发送",
  a_respond: "回复",
  a_delete: "删除",
  a_deleted: "已删除",
  a_media_desc: "媒体存储按区域划分。删除整个区域以释放空间。",
  a_loading: "加载中…",
  a_chat_media: "聊天媒体",
  a_social_media: "社交媒体",
  a_market_media: "市场媒体",
  a_files: "个文件",
  a_currency: "货币",
  a_currency_note: "卖家现在自行选择店铺货币。费用、税费和套餐价格以美元计费。",
  a_platform_fee: "平台费用（%）",
  a_reports: "举报",
  a_no_reports: "没有市场举报 🎉",
  a_report: "举报",
  a_warned: "已警告",
  a_seller_suspended: "卖家已封禁",
  a_dismissed: "已驳回",
  a_seller: "卖家",
  a_user_gone: "账户已删除",
  a_item: "商品",
  a_reason: "原因",
  a_no_reason: "未提供原因",
  a_reported_by: "举报人",
  a_warn: "警告",
  a_unsuspend: "解除封禁",
  a_suspend: "封禁",
  a_dismiss: "驳回",
  a_confirm_suspend: "封禁此卖家？其店铺和商品将被隐藏，并在解除封禁前无法登录。",
  a_warn_sent: "已向卖家发送警告",
  a_suspended_ok: "卖家已封禁",
  a_unsuspended_ok: "卖家已重新启用",
  a_dismissed_ok: "举报已驳回",
  a_commission: "平台佣金（%）",
  a_commission_note: "佣金从卖家一方的每笔销售中收取——买家始终支付标示价格。",
  a_payout_setup: "卖家收款设置",
  a_sell_shops: "销售店铺",
  a_payout_done: "收款就绪",
  a_payout_pending: "待处理",
  a_welcome_title: "欢迎消息",
  a_welcome_desc: "在用户注册的那一刻由 RoyalChat Nova 自动发送给每位用户。",
  a_welcome_from: "以此身份发送",
  a_welcome_lang_hint: "选择一种语言，然后编辑以该语言注册的用户所看到的消息。留空的语言将回退为英文。",
  a_welcome_saved: "欢迎消息已保存",
  a_on: "开",
  a_off: "关",
  a_tax_percent: "销售税（%）",
  a_sub_tiers: "订阅等级（按店铺规模）",
  a_max_items: "最大商品数",
  a_price_mo: "价格 /月",
  a_can_sell_paid: "可在线销售（付费功能）",
  a_listings_boost: "刊登与推广",
  a_listing_duration: "刊登时长（商品过期前的天数）",
  a_boost_opts: "推广选项（将商品置顶到浏览页）",
  a_days: "天",
  a_price: "价格",
  a_categories: "分类",
  a_cat_desc: "以逗号分隔的列表，供买家筛选",
  a_save_market: "保存市场设置",
  a_sellers_shops: "卖家 / 店铺",
  a_items: "件商品",
  a_subscribed: "已订阅",
  a_unverify: "取消认证",
  a_verify: "认证",
  a_no_shops: "还没有店铺",
  a_terms_desc: "编辑向用户展示的条款与条件（涵盖聊天、社交和市场）。Markdown 风格：用 # 和 ## 作标题。",
  a_save_terms: "保存条款",
  a_free_space: "立即释放空间",
  a_what_delete: "删除内容",
  a_select_all: "全选",
  a_clear: "清除",
  a_images: "图片",
  a_videos: "视频",
  a_audio: "音频",
  a_documents: "文档",
  a_scope: "范围",
  a_older_than: "早于…",
  a_delete_all: "全部删除",
  a_delete_older_days: "删除早于（天）的项目",
  a_delete_all_warn: "⚠️ 这将永久删除每个选定项目，无论存放时间长短。此操作无法撤销。",
  a_also_delete_files: "同时删除已存文件（释放最多空间）",
  a_running: "运行中…",
  a_delete_all_now: "立即删除全部选定",
  a_run_cleanup: "立即运行清理",
  a_sched_cleanup: "计划清理（每日）",
  a_autodelete_days: "自动删除早于（天）",
  a_save_schedule: "保存计划",
  a_custom_invite: "自定义邀请消息",
  a_save_message: "保存消息",
  a_load_failed: "管理后台加载失败",
  a_failed: "失败",
  a_market_saved: "市场设置已保存",
  a_terms_saved: "条款已保存",
  a_verified: "已认证",
  a_unverified: "未认证",
  a_updated: "已更新",
  a_delete_user_q: "删除用户？",
  a_pw_min: "密码至少需要 6 个字符",
  a_pw_updated: "密码已更新",
  a_pw_fail: "无法更新密码",
  a_upload_failed: "上传失败",
  a_reply_sent: "回复已发送",
  a_pick_category: "请至少选择一个要删除的分类",
  a_schedule_saved: "计划已保存",
  a_invite_saved: "邀请消息已保存",
  a_confirm_del_media: "删除此区域的所有媒体文件？此操作无法撤销。",
  a_files_deleted: "个文件已删除",
  a_confirm_cleanup: "删除选定的媒体？此操作无法撤销。",
  a_removed: "已移除",
  a_sent_broadcast: "广播已发送",
  ss_title: "社交设置",
  ss_desc: "一段时间后自动删除我的帖子。让你的动态保持整洁——仅影响你自己的帖子。",
  ss_saved: "已保存",
  ss_never: "从不（永久保留）",
  ss_1m: "1 个月后",
  ss_3m: "3 个月后",
  ss_6m: "6 个月后",
  ss_12m: "12 个月后",
  set_available: "在 RoyalChat Nova 上可用",
  set_invite_title: "邀请好友",
  set_invite_desc: "与你的联系人分享 RoyalChat Nova",
  set_suggest_title: "发送建议",
  set_suggest_desc: "帮助我们改进——附上一张截图",
  set_away_title: "离开时邮件提醒",
  set_social_market: "社交与市场",
  set_social_desc: "自动删除旧帖子等",
  set_market_desc: "管理你的店铺、商品和仪表盘",
  set_terms_desc: "聊天、社交与市场",
  set_installed: "应用已安装",
  set_installed_toast: "已安装 ✓",
  set_ios_install: "Safari：分享 ← 添加到主屏幕",
  set_browser_install: "浏览器菜单 ← 安装应用",
  set_not_supported: "此设备不支持",
  set_notif_fail: "无法启用通知",
  m_photos_max: "照片（最多 5 张）",
  m_add_video: "添加视频",
  m_video: "展示视频",
  m_remove_video: "移除视频",
  m_stock_label: "库存数量",
  m_stock_ph: "留空表示不限",
  m_variants: "规格（颜色、尺码…）",
  m_add_option: "添加选项",
  m_option_name_ph: "选项名称（例如 颜色）",
  m_option_values_ph: "以逗号分隔的值（例如 红色、蓝色）",
  m_variant_stock: "每个选项的库存",
  m_promo: "促销",
  m_promo_price: "促销价",
  m_promo_days: "促销持续（天）",
  m_off: "折扣",
  m_ends_in: "结束于",
  m_day_short: "天",
  m_only_left: "仅剩 {n} 件",
  m_more_from_shop: "该店铺的更多商品",
  m_select_options: "选择规格",
  m_shop_avatar: "店铺头像（小）",
  m_shop_banner: "店铺横幅（大）",
  m_upload_photo: "上传",
  m_change_photo: "更换",
  m_featured_shops: "精选店铺",
  m_recently_viewed: "最近浏览",
  m_shop_items: "商品",
  m_shop_no_items: "该店铺还没有商品",
  m_cart_empty: "你的购物车是空的",
  m_cart_empty_hint: "浏览商品并添加到这里",
  m_choose_options_first: "请先选择规格",
  m_processing: "处理中…",
};

